{
  "401": {
    "title": "U bent niet bevoegd om deze pagina te openen.",
    "text": "Als u denkt dat dit niet klopt, neem dan contact op met de beheerder",
    "back_button": "Terug naar dashboard"
  },
  "403": {
    "title": "U heeft geen toestemming om deze pagina te openen.",
    "text": "Als u denkt dat dit een vergissing is, neem dan contact op met de beheerder.",
    "back_button": "Terug naar dashboard"
  },
  "404": {
    "title": "Deze pagina is niet gevonden.",
    "text": "De opgevraagde pagina kon niet worden gevonden.",
    "back_button": "Terug naar dashboard"
  },
  "general": {
    "dateFormat": "dd/MM/yyyy",
    "fullDateFormat": "dd/MM/yyyy HH:mm:ss",
    "logout": "Uitloggen",
    "account": "Account",
    "profile": "Profiel",
    "hello": "Hallo",
    "home": "Home",
    "loading": "Laden...",
    "confirm": "Bevestigen",
    "cancel": "Annuleren",
    "close": "Sluiten",
    "view": "Bekijken",
    "save": "Opslaan",
    "records": "Records",
    "add": "Toevoegen",
    "read": "Lezen",
    "write": "Opslaan",
    "edit": "Bewerken",
    "new": "Nieuw",
    "delete": "Verwijderen",
    "actions": "Acties",
    "active": "Actief",
    "inactive": "Inactief",
    "search": "Zoeken",
    "select": "Selecteren",
    "none": "Geen",
    "yes": "Ja",
    "no": "Nee",
    "years": "Jaren",
    "months": "Maanden",
    "favorites": "Favorieten",
    "reports": "Rapporten",
    "recordsPerPage": "Records per pagina",
    "changePassword": "Wachtwoord wijzigen",
    "longDateFormat": "{years} jaar en {months} maand(en)",
    "importData": "Gegevens importeren",
    "upload": "Uploaden",
    "downloadTemplate": "Sjabloon downloaden",
    "selectOption": "Selecteer een optie",
    "id": "ID",
    "translations": "Vertalingen",
    "or": "of",
    "review": "Beoordelen",
    "approve": "Goedkeuren",
    "reject": "Afwijzen",
    "reviewComments": "Beoordelingsopmerkingen",
    "reviewOnBehalfOf": "Beoordelen namens",
    "reviewed": "Beoordeeld",
    "reviewedBy": "Beoordeeld door ",
    "pending": "In behandeling",
    "approved": "Goedgekeurd",
    "rejected": "Afgewezen",
    "skipped": "Overgeslagen",
    "warning": "Waarschuwing",
    "manager": "Manager",
    "move": "Verplaatsen",
    "leave": "Verlof",
    "export": "Exporteren",
    "import": "Importeren",
    "next": "Volgende",
    "previous": "Vorige",
    "done": "Gereed",
    "run": "Uitvoeren",
    "form": "Formulier",
    "status": "Status",
    "emailTemplate": "E-mailsjabloon",
    "send": "Verzenden",
    "saving": "Bezig met opslaan...",
    "saved": "Opgeslagen",
    "loadData": "Gegevens laden",
    "download": "Downloaden",
    "noData": "Geen gegevens beschikbaar in de tabel",
    "cropImage": "Afbeelding bijsnijden",
    "selectImageToCrop": "Selecteer een afbeelding om bij te snijden",
    "selectImage": "Afbeelding selecteren",
    "list": "Lijst",
    "group": "Groep",
    "attach": "Bijvoegen",
    "exportCsv": "CSV exporteren",
    "auditFields": "Auditvelden",
    "saveDisplayOrder": "Weergavevolgorde opslaan",
    "permissionActions": {
      "read": "Lezen",
      "write": "Schrijven",
      "delete": "Verwijderen",
      "execute": "Uitvoeren"
    },
    "messages": {
      "personNotFound": "Persoon niet gevonden. Neem contact op met de beheerder.",
      "notRegisteredSessionOnly": "U bent niet geregistreerd in JTP, dus deze wijziging geldt alleen voor uw huidige sessie. Neem contact op met de beheerder om te worden toegevoegd.",
      "formUnsavedChanges": "U heeft niet-opgeslagen wijzigingen. Weet u zeker dat u wilt sluiten?",
      "serverError": "Serverfout. Probeer het later opnieuw of neem contact op met de systeembeheerder.",
      "networkError": "Kan geen verbinding maken met de server. Controleer uw internetverbinding of neem contact op met de systeembeheerder.",
      "forbidden": "U heeft geen toestemming om deze bron te openen. Neem contact op met de systeembeheerder als u denkt dat dit een vergissing is.",
      "fileUploadError": "Fout bij het uploaden van het bestand. Controleer het bestandsformaat en de bestandsgrootte en probeer het opnieuw.",
      "fileUploadSuccessEmail": "Bestand succesvol geüpload. Binnenkort ontvangt u een e-mail met het importresultaat.",
      "failedLoadPermissions": "Het laden van gebruikersrechten is mislukt. Vernieuw de pagina of neem contact op met de systeembeheerder.",
      "downloadingFile": "Bestand wordt gedownload...",
      "fileDownloadError": "Fout bij het downloaden van het bestand. Probeer het opnieuw of neem contact op met de systeembeheerder.",
      "fileImportedSuccessfully": "Bestand succesvol geïmporteerd.",
      "invalidFileFormat": "Ongeldig bestandsformaat. Controleer het bestand en probeer het opnieuw.",
      "exportFailed": "Het exporteren van gegevens is mislukt. Probeer het opnieuw of neem contact op met de systeembeheerder.",
      "unableGetPermissions": "JTP kan uw rechten niet ophalen. U kunt werken met basistoegang totdat dit probleem is opgelost"
    },
    "warnings": {
      "maxDisplayedRecords": "{shown} records van {filtered} worden weergegeven. Gebruik de zoekfunctie om aanvullende records te bekijken."
    },
    "info": {
      "dragAndDropInfo": "Sleep een persoon om de structuur te organiseren"
    },
    "validation": {
      "required": "Dit veld is verplicht.",
      "email": "Voer een geldig e-mailadres in.",
      "minValue": "De waarde moet ten minste {min} zijn.",
      "maxValue": "De waarde mag niet groter zijn dan {max}.",
      "minLength": "De waarde moet ten minste {min} tekens bevatten.",
      "maxLength": "De waarde mag niet meer dan {max} tekens bevatten.",
      "onlyIntegers": "De waarde moet een geheel getal zijn.",
      "invalidDate": "De ingevoerde datum is ongeldig.",
      "dateAfterOrEqual": "Datum moet na of gelijk aan {date} zijn"
    },
    "baseAuditableEntity": {
      "createdBy": "Aangemaakt door",
      "createdDate": "Aanmaakdatum",
      "modifiedBy": "Gewijzigd door",
      "modifiedDate": "Wijzigingsdatum"
    }
  },
  "enums": {
    "potentialSuccessorType": {
      "1": "Intern",
      "2": "Extern"
    },
    "readinessFactor": {
      "0": "N.v.t.",
      "1": "Nu klaar",
      "2": "Klaar met ontwikkeling (1-2 jaar)",
      "3": "Klaar met ontwikkeling (2-3 jaar)",
      "4": "Noodvervanging"
    },
    "positionType": {
      "1": "Kopen",
      "2": "Maken",
      "3": "Verkopen",
      "4": "Ondersteunen"
    },
    "personStatus": {
      "1": "Actief",
      "2": "Inactief",
      "3": "Uit dienst"
    },
    "communicationPriority": {
      "1": "Normaal",
      "2": "Hoog"
    },
    "personTypes": {
      "0": "Onbekend",
      "1": "Salariswerknemer",
      "2": "Aannemer",
      "3": "Leverancier",
      "4": "Uurloonwerknemer",
      "5": "Extern",
      "6": "DU Uurloon Inactief",
      "7": "DU Salaris Inactief",
      "8": "DU Vrachtwagenchauffeur In",
      "9": "Directielid",
      "10": "Vakbond",
      "11": "Geen vakbond",
      "12": "Mogelijk vakbond",
      "13": "Salaris Niet-vrijgesteld",
      "14": "Uurloon",
      "15": "DU Betaald Verlof",
      "17": "Vrachtwagenchauffeur",
      "18": "DU Onbetaald Verlof",
      "19": "Werkvrijstelling",
      "20": "Externe toegang niveau één",
      "21": "Externe toegang niveau twee",
      "22": "Externe toegang niveau drie",
      "23": "Externe toegang niveau vier",
      "24": "Externe toegang niveau vijf",
      "99": "Wereldwijde werknemer"
    },
    "customerSpecificStatus": {
      "0": "Onbekend",
      "1": "Actief",
      "2": "Inactief",
      "3": "Inkomensondersteuning",
      "4": "Verlof",
      "5": "Gepensioneerd",
      "6": "Ingetrokken"
    },
    "resourceType": {
      "1": "Applicatie",
      "2": "Module",
      "3": "Pagina",
      "4": "Paginasectie",
      "5": "Pagina-actie",
      "6": "Paginaveld",
      "7": "Gegevens"
    },
    "securityResourceAction": {
      "0": "Geen",
      "1": "Lezen",
      "2": "Schrijven",
      "3": "Lezen en schrijven",
      "4": "Uitvoeren",
      "5": "Lezen en uitvoeren",
      "6": "Schrijven en uitvoeren",
      "7": "Lezen, schrijven en uitvoeren",
      "8": "Verwijderen",
      "9": "Lezen en verwijderen",
      "10": "Schrijven en verwijderen",
      "11": "Lezen, schrijven en verwijderen",
      "12": "Uitvoeren en verwijderen",
      "13": "Lezen, uitvoeren en verwijderen",
      "14": "Schrijven, uitvoeren en verwijderen",
      "15": "Alles"
    }
  },
  "report": {
    "viewer": {
      "grid": {
        "pivotMode": "Draaitabelmodus",
        "groups": "Rijgroepen",
        "rowGroupColumnsEmptyMessage": "Sleep hier naartoe om rijgroepen in te stellen",
        "values": "Waarden",
        "valueColumnsEmptyMessage": "Sleep hier naartoe om te aggregeren",
        "pivots": "Kolomlabels",
        "pivotColumnsEmptyMessage": "Sleep hier naartoe om kolomlabels in te stellen",
        "columns": "Kolommen",
        "filters": "Filters",
        "loadingOoo": "Bezig met laden...",
        "noRowsToShow": "Geen rijen om weer te geven",
        "enabled": "Ingeschakeld",
        "group": "Groep",
        "footerTotal": "Totaal",
        "filterOoo": "Filteren...",
        "searchOoo": "Zoeken...",
        "blanks": "(Leeg)",
        "selectAll": "(Alles selecteren)",
        "selectAllSearchResults": "(Alle zoekresultaten selecteren)",
        "noMatches": "Geen overeenkomsten",
        "equals": "Is gelijk aan",
        "notEqual": "Is niet gelijk aan",
        "blank": "Leeg",
        "notBlank": "Niet leeg",
        "lessThan": "Kleiner dan",
        "greaterThan": "Groter dan",
        "lessThanOrEqual": "Kleiner dan of gelijk aan",
        "greaterThanOrEqual": "Groter dan of gelijk aan",
        "inRange": "Tussen",
        "inRangeStart": "Van",
        "inRangeEnd": "Tot",
        "contains": "Bevat",
        "notContains": "Bevat niet",
        "startsWith": "Begint met",
        "endsWith": "Eindigt met",
        "before": "Voor",
        "after": "Na",
        "andCondition": "EN",
        "orCondition": "OF",
        "applyFilter": "Toepassen",
        "resetFilter": "Resetten",
        "clearFilter": "Wissen",
        "cancelFilter": "Annuleren",
        "textFilter": "Tekstfilter",
        "numberFilter": "Getalfilter",
        "dateFilter": "Datumfilter",
        "setFilter": "Setfilter",
        "pinColumn": "Kolom vastzetten",
        "pinLeft": "Links vastzetten",
        "pinRight": "Rechts vastzetten",
        "noPin": "Niet vastzetten",
        "valueAggregation": "Waardeaggregatie",
        "noAggregation": "Geen",
        "autosizeThisColumn": "Automatische breedte voor deze kolom",
        "autosizeAllColumns": "Automatische breedte voor alle kolommen",
        "groupBy": "Groeperen op",
        "ungroupBy": "Groepering opheffen op",
        "ungroupAll": "Alle groeperingen opheffen",
        "addToValues": "Voeg {'${variable}'} toe aan waarden",
        "removeFromValues": "Verwijder {'${variable}'} uit waarden",
        "addToLabels": "Voeg {'${variable}'} toe aan labels",
        "removeFromLabels": "Verwijder {'${variable}'} uit labels",
        "resetColumns": "Kolommen resetten",
        "expandAll": "Alle rijgroepen uitvouwen",
        "collapseAll": "Alle rijgroepen samenvouwen",
        "copy": "Kopiëren",
        "copyWithHeaders": "Kopiëren met kolomkoppen",
        "copyWithGroupHeaders": "Kopiëren met groepskoppen",
        "cut": "Knippen",
        "paste": "Plakken",
        "export": "Exporteren",
        "csvExport": "CSV-export",
        "excelExport": "Excel-export",
        "sum": "Som",
        "first": "Eerste",
        "last": "Laatste",
        "min": "Min",
        "max": "Max",
        "count": "Aantal",
        "avg": "Gemiddelde",
        "average": "Gemiddelde",
        "filteredRows": "Gefilterd",
        "selectedRows": "Geselecteerd",
        "totalRows": "Totaal aantal rijen",
        "totalAndFilteredRows": "Rijen"
      },
      "noFilterMessage": "Geen filters voor dit rapport",
      "noAccessReport": "U heeft geen toegang om dit rapport te bekijken. Neem contact op met de systeembeheerder als u denkt dat dit een vergissing is.",
      "pdfSizeErrorMessage": "De PDF is te groot en kan niet worden weergegeven.",
      "pdfMaxSizeDownloaded": "Het rapport is te groot om weer te geven. Controleer uw downloadmap.",
      "failedLoadReports": "Het laden van rapporten is mislukt. Andere functies werken zoals verwacht. Vernieuw de pagina of neem contact op met de systeembeheerder als het probleem aanhoudt.",
      "run": "Uitvoeren",
      "download": "Downloaden",
      "viewFilter": {
        "button": "Filters bekijken...",
        "title": "Parameters",
        "name": "Naam",
        "value": "Waarde"
      },
      "fullScreen": "Volledig scherm...",
      "smallScreen": "Klein scherm...",
      "tabButton": {
        "fullScreen": "Parametersectie verbergen",
        "smallScreen": "Parametersectie tonen",
        "about": "Over",
        "downloadExcel": "Spreadsheetbestand downloaden",
        "clear": "Alle tabbladen sluiten"
      },
      "modalAbout": {
        "title": "Over",
        "description": "Beschrijving",
        "version": "Versie",
        "reference": "Referentie",
        "lastChange": "Laatste wijziging",
        "dataSource": "Gegevensbron"
      }
    },
    "maintenance": {
      "menuName": "Rapporten",
      "pageTitle": "Rapporten",
      "id": "ID",
      "title": "Titel",
      "reference": "Referentie",
      "directoryTree": "Mapstructuur",
      "directoryTreeHelp": "Gebruik een backslash om mappen te scheiden, bijv. Rapporten\\Financiën\\Maandelijks",
      "reportType": "Rapporttype",
      "typeGrid": "Raster",
      "typeForm": "Formulier",
      "securityResource": "Beveiligingsbron",
      "description": "Beschrijving",
      "versionNumber": "Versie",
      "isActive": "Actief",
      "lastModified": "Laatst gewijzigd",
      "isSchedulable": "Planbaar",
      "isArchivable": "Archiveerbaar",
      "isAuditable": "Auditeerbaar",
      "passMultiValue": "Meerdere waarden doorgeven als tekst",
      "expireInDays": "Verlopen na (dagen)",
      "add": "Rapport toevoegen",
      "edit": "Rapport bewerken",
      "delete": {
        "title": "Rapport verwijderen",
        "text": "Weet u zeker dat u \"{name}\" wilt verwijderen?"
      },
      "messages": {
        "created": "Rapport succesvol aangemaakt.",
        "updated": "Rapport succesvol opgeslagen.",
        "deleted": "Rapport succesvol verwijderd.",
        "imported": "Rapport succesvol geïmporteerd."
      },
      "sections": {
        "main": "Hoofdeigenschappen",
        "parameters": "Parameters",
        "sqls": "SQL-instructies",
        "grids": "Resultaatrasters",
        "models": "Rapportmodellen"
      },
      "sql": {
        "add": "SQL-instructie toevoegen",
        "edit": "SQL-instructie bewerken",
        "description": "Beschrijving",
        "connection": "Verbinding",
        "multipleResultset": "Meerdere resultaatsets",
        "sql": "SQL",
        "generateGrids": "Rasters genereren vanuit SQL",
        "generateGridsSuccess": "Raster succesvol gegenereerd. Bekijk het op het tabblad Resultaatrasters.",
        "delete": {
          "title": "SQL-instructie verwijderen",
          "text": "Weet u zeker dat u \"{name}\" wilt verwijderen?"
        }
      },
      "grid": {
        "add": "Raster toevoegen",
        "edit": "Raster bewerken",
        "label": "Label",
        "resultsetNumber": "Resultaatset #",
        "parentGrid": "Bovenliggend raster",
        "defaultGroupedColumns": "Standaard gegroepeerde kolommen",
        "relationString": "Relatiestring",
        "delete": {
          "title": "Raster verwijderen",
          "text": "Weet u zeker dat u \"{name}\" wilt verwijderen?"
        }
      },
      "column": {
        "add": "Kolom toevoegen",
        "edit": "Kolom bewerken",
        "columnName": "Kolomnaam",
        "label": "Label",
        "header": "Kop",
        "dataType": "Gegevenstype",
        "sumarizeType": "Samenvatten",
        "showOrder": "Volgorde",
        "mask": "Masker",
        "helpText": "Hulptekst",
        "template": "Sjabloon",
        "delete": {
          "title": "Kolom verwijderen",
          "text": "Weet u zeker dat u \"{name}\" wilt verwijderen?"
        }
      },
      "param": {
        "add": "Parameter toevoegen",
        "edit": "Parameter bewerken",
        "displayOrder": "Volgorde",
        "name": "Naam",
        "nameValidation": "Alleen letters, cijfers en underscores zijn toegestaan.",
        "label": "Label",
        "dataType": "Gegevenstype",
        "defaultValue": "Standaardwaarde",
        "helpText": "Hulptekst",
        "required": "Verplicht",
        "multiple": "Meerdere waarden",
        "width": "Breedte (kolommen)",
        "enumValues": "Waarden (gescheiden door puntkomma's)",
        "enumValuesHelp": "bijv. 1;2;3",
        "enumLabels": "Labels (gescheiden door puntkomma's)",
        "enumLabelsHelp": "bijv. Optie A;Optie B;Optie C",
        "sql": "SQL-query",
        "generate": "Parameters genereren vanuit SQL",
        "delete": {
          "title": "Parameter verwijderen",
          "text": "Weet u zeker dat u \"{name}\" wilt verwijderen?"
        }
      },
      "model": {
        "add": "Model toevoegen",
        "edit": "Model bewerken",
        "description": "Beschrijving",
        "order": "Volgorde",
        "connection": "Verbinding",
        "file": "Modelbestand (.trdx / .trdp)",
        "fileLoaded": "Bestand succesvol geladen.",
        "delete": {
          "title": "Model verwijderen",
          "text": "Weet u zeker dat u \"{name}\" wilt verwijderen?"
        }
      },
      "paramDataType": {
        "text": "Tekst",
        "number": "Getal",
        "date": "Datum",
        "time": "Tijd",
        "combo": "Keuzelijst",
        "boolean": "Booleaans",
        "sql": "SQL"
      },
      "colDataType": {
        "text": "Tekst",
        "number": "Getal",
        "date": "Datum",
        "time": "Tijd",
        "combo": "Keuzelijst",
        "boolean": "Booleaans"
      },
      "sumarizeType": {
        "nosumarize": "Geen",
        "sum": "Som",
        "min": "Min",
        "max": "Max",
        "average": "Gemiddelde",
        "count": "Aantal"
      },
      "import": {
        "connection": "Verbinding overschrijven",
        "connectionHelp": "Optioneel: overschrijf alle verbindingsreferenties in het geïmporteerde bestand."
      }
    }
  },
  "file": {
    "description": "Beschrijving",
    "files": "Bestanden",
    "editDescription": "Beschrijving bewerken",
    "delete": "Bestand verwijderen",
    "download": "Bestand downloaden",
    "pendingUpload": "In afwachting van upload. Het bestand wordt pas opgeslagen na het klikken op 'Opslaan'.",
    "noFiles": "Geen bestanden toegevoegd."
  },
  "dashboard": {
    "menuTitle": "Dashboard",
    "title": "Dashboard",
    "addWidget": "Widget toevoegen",
    "editLayout": "Lay-out bewerken",
    "saveLayout": "Lay-out opslaan",
    "importLayout": "Lay-out importeren",
    "exportLayout": "Lay-out exporteren",
    "category": "Categorie",
    "widget": "Widget",
    "widgetTitle": "Titel",
    "widgetParameters": "Parameters",
    "widgetInformation": "Widgetinformatie",
    "noParameters": "Deze widget heeft geen parameters.",
    "delete": "Widget verwijderen",
    "viewLink": "bekijken",
    "noItemsToDisplay": "Geen items om weer te geven",
    "messages": {
      "saveSuccess": "Lay-out succesvol opgeslagen.",
      "importSuccess": "Lay-out succesvol geïmporteerd.",
      "exportSuccess": "Lay-out succesvol geëxporteerd.",
      "importFailed": "Het importeren van de lay-out is mislukt.",
      "widgetNotFound": "Widget niet gevonden",
      "failedToLoad": "Laden mislukt",
      "noDataAvailable": "Geen gegevens beschikbaar",
      "noParametersConfigured": "Er zijn geen parameters geconfigureerd voor deze widget."
    },
    "tutorial": {
      "mainMessage": "Welkom bij uw dashboard! Gebruik de knoppen hierboven om het aan te passen.",
      "callToAction": "Laat me zien hoe!",
      "instructions": {
        "add": {
          "title": "Knop Widget toevoegen",
          "description": "Hier kunt u widgets per categorie vinden. Sommige hebben parameters waarmee u een volledig aanpasbaar dashboard kunt maken. Vergeet niet op OPSLAAN te klikken nadat u al uw widgets heeft toegevoegd."
        },
        "edit": {
          "title": "Widgetlay-out bewerken",
          "description": "Hier kunt u uw dashboard wijzigen: widgets toevoegen of verwijderen, verplaatsen en van grootte veranderen. Vergeet niet op opslaan te klikken na het bewerken."
        },
        "import": {
          "title": "Lay-out importeren",
          "description": "Met een back-upbestand kunt u dit hier importeren. Let op: uw dashboard wordt overschreven."
        },
        "export": {
          "title": "Lay-out exporteren",
          "description": "Zodra uw dashboard compleet is, kunt u het exporteren om een back-up te hebben OF het naar een andere gebruiker sturen om uw dashboard te kopiëren."
        }
      }
    }
  },
  "communication": {
    "title": "Communicatie",
    "menuTitle": "Communicatie",
    "menuName": "Communicatie",
    "markAsRead": "Markeren als gelezen",
    "subject": "Onderwerp",
    "date": "Datum",
    "priority": "Prioriteit",
    "backToInbox": "Terug naar inbox",
    "noMessages": "Geen berichten in uw inbox.",
    "status": "Status",
    "read": "Gelezen",
    "unread": "Ongelezen",
    "edit": "Bekijken",
    "messages": {
      "markedAsRead": "Communicatie bevestigd"
    }
  },
  "settings": {
    "title": "Instellingen",
    "theme": {
      "name": "Thema",
      "dark": "Donker",
      "light": "Licht"
    }
  },
  "userInfo": {
    "title": "Gebruikersinformatie",
    "permissions": "Rechten",
    "userName": "Gebruikersnaam",
    "fullName": "Volledige naam",
    "email": "E-mail",
    "employeeId": "Werknemer-ID",
    "action": "Actie",
    "permissionCode": "Rechtcode"
  },
  "profile": {
    "title": "Mijn profiel",
    "menuName": "Profiel",
    "score": "Profielscore",
    "managerWarning": "Informatie die u verstrekt op de pagina 'Mijn profiel' is toegankelijk voor managers en HR binnen de organisatie voor doeleinden van talentmapping.",
    "photo": "Foto wijzigen",
    "name": "Naam",
    "email": "E-mail",
    "manager": "Manager",
    "position": "Functie",
    "plant": "Vestiging",
    "businessArea": "Bedrijfsgebied",
    "degreeType": "Diploma",
    "degreeName": "Naam van diploma of certificaat hier",
    "language": "Talen",
    "languagesInfo": "Selecteer alle talen die u spreekt",
    "geoMobility": {
      "label": "Geografische mobiliteit",
      "none": "Geen",
      "local": "Lokaal",
      "national": "Nationaal",
      "international": "Internationaal",
      "nationalAndInternational": "Nationaal en internationaal"
    },
    "businessMobility": "Mobiliteit tussen bedrijfsonderdelen",
    "skills": "Mijn vaardigheden",
    "skillsInfo": "Selecteer uw expertisegebieden",
    "careerInterests": "Loopbaaninteresses",
    "careerAspirations": "Loopbaanambities",
    "jobHistory": "Relevante werkgeschiedenis",
    "save": "Opslaan",
    "invalidPhotoFormat": "Bestandsformaat niet ondersteund. Gebruik PNG of JPEG.",
    "photoCrop": {
      "title": "Profielfoto",
      "selectImage": "Uploaden",
      "confirm": "Toepassen",
      "cancel": "Annuleren",
      "deletePhoto": "Verwijderen",
      "hint": "Sleep om te verplaatsen. Knijp of scroll om in of uit te zoomen.",
      "emptyState": "Geen afbeelding geselecteerd. Klik op \"Uploaden\" om te beginnen."
    },
    "messages": {
      "saved": "Profiel succesvol opgeslagen",
      "notRegistered": "U bent niet geregistreerd in JTP. Neem contact op met HR om te worden toegevoegd. Tot die tijd is uw toegang beperkt."
    }
  },
  "impersonate": {
    "title": "Gebruiker imiteren",
    "userName": "Login",
    "start": "Imitatie starten",
    "messages": {
      "impersonationStarted": "Imitatiesessie gestart. Om terug te keren naar uw eigen account, logt u uit en weer in.",
      "userNotFound": "Gebruiker niet gevonden. Controleer de gebruikersnaam en probeer het opnieuw."
    }
  },
  "about": {
    "menuName": "Over",
    "title": "Over"
  },
  "releaseNotes": {
    "menuName": "Releasenotities",
    "title": "Releasenotities",
    "name": "Naam",
    "version": "Versie",
    "description": "Beschrijving",
    "appType": "Applicatietype",
    "releaseDate": "Releasedatum",
    "messages": {
      "notFound": "Releasenotitie niet gevonden.",
      "saveError": "Fout bij het opslaan van de releasenotitie. Probeer het later opnieuw."
    }
  },
  "help": {
    "menuTitle": "Help",
    "externalLinkMessage": "U staat op het punt een externe link te openen:",
    "externalLinkConfirm": "Link openen",
    "lastUpdated": "Laatst bijgewerkt: {date}",
    "wasThisHelpful": "Was dit nuttig?",
    "helpful": "Nuttig",
    "notHelpful": "Niet nuttig",
    "pageModal": {
      "title": "Help voor deze pagina",
      "intro": "Helpartikelen geven u begeleiding voor de pagina waarop u zich bevindt. Selecteer er een om te openen, of sluit dit venster."
    }
  },
  "admin": {
    "menuTitle": "Beheer",
    "appCustomizations": {
      "menuName": "App-aanpassingen",
      "pageTitle": "App-aanpassingen",
      "imageLogos": "Afbeeldingslogo's",
      "headerLogo": "Headerlogo",
      "menuLogo": "Menulogo",
      "bannerImage": "Bannerafbeelding",
      "upload": "Uploaden",
      "remove": "Verwijderen",
      "noCustom": "Standaardafbeelding",
      "preview": "Voorbeeld",
      "messages": {
        "saved": "Aanpassingen succesvol opgeslagen.",
        "invalidKey": "Ongeldige logosleutel.",
        "invalidLanguage": "Ongeldige taalcode.",
        "fileRequired": "Bestand is verplicht.",
        "fileTooLarge": "Bestand overschrijdt de maximaal toegestane grootte van 2 MB.",
        "fileTypeNotAllowed": "Bestandstype niet toegestaan. Gebruik PNG, JPEG of WebP.",
        "notFound": "Aanpassing niet gevonden."
      }
    },
    "help": {
      "menuName": "Help",
      "pageTitle": "Help",
      "title": "Titel",
      "description": "Beschrijving",
      "isActive": "Actief",
      "isMenuDisplayed": "Weergeven in menu",
      "isMenuDisplayedInfo": "Indien uitgeschakeld, is deze help verborgen in het Help-menu, maar kan deze nog steeds worden geopend via het help-icoon op de bijbehorende pagina's.",
      "isTrackingEnabled": "Tracking inschakelen",
      "isTrackingEnabledInfo": "Indien ingeschakeld, worden paginaweergaven per werknemer geregistreerd en wordt een \"was dit nuttig\"-beoordeling getoond op de helppagina.",
      "viewCount": "Weergaven",
      "viewCountValue": "{views} keer bekeken door {viewers} personen",
      "viewCountInfo": "Totaal aantal weergaven en het aantal unieke werknemers dat deze help heeft geopend.",
      "helpfulCount": "Nuttig",
      "notHelpfulCount": "Niet nuttig",
      "displayOrder": "Weergavevolgorde",
      "securityResources": "Beveiligingsbronnen",
      "securityResourcesInfo": "Kommagescheiden lijst van rechten. Laat leeg om dit voor iedereen beschikbaar te maken; anders moet de gebruiker ten minste een van de vermelde rechten hebben.",
      "associatedMenus": "Gekoppelde pagina's",
      "associatedMenusInfo": "Koppel deze help aan een of meer pagina's zodat deze direct kan worden geopend via het help-icoon op die pagina's.",
      "addMenu": "Pagina toevoegen",
      "add": "Help toevoegen",
      "edit": "Help bewerken",
      "delete": {
        "title": "Help verwijderen",
        "text": "Weet u zeker dat u dit help-item wilt verwijderen?"
      },
      "messages": {
        "created": "Help succesvol aangemaakt.",
        "updated": "Help succesvol bijgewerkt.",
        "deleted": "Help succesvol verwijderd.",
        "notFound": "Help niet gevonden."
      }
    },
    "menuHierarchy": {
      "menuName": "Menuhiërarchie",
      "pageTitle": "Menuhiërarchie",
      "displayName": "Weergavenaam",
      "displayNameKey": "Isso????",
      "route": "Route",
      "routeParam": "Menuparameter",
      "securityResources": "Beveiligingsbronnen",
      "children": "Submenu's",
      "isActive": "Actief",
      "icon": "Icoon",
      "iconHelpText": "Iconenbibliotheek",
      "displayOrder": "Weergavevolgorde",
      "edit": "Menu-item bewerken",
      "messages": {
        "success": "Menu-item succesvol opgeslagen."
      }
    },
    "notificationTemplate": {
      "menuName": "Meldingssjabloon",
      "pageTitle": "Meldingssjabloon",
      "name": "Naam",
      "parent": "Bovenliggend sjabloon",
      "parentInfo": "Alleen sjablonen die beginnen met masterTemplate kunnen worden gebruikt als bovenliggend sjabloon.",
      "pushNotificationEnabled": "Pushmelding ingeschakeld",
      "pushRoute": "Route pushmelding",
      "sqlQuery": "SQL-query",
      "sqlQueryDateFormatInfo": "Datumkolommen moeten worden opgemaakt in het formaat mm/DD/jjjj.",
      "generalSection": "Algemene informatie",
      "emailSection": "E-mailmelding",
      "emailSubject": "E-mailonderwerp",
      "emailBody": "E-mailinhoud (HTML)",
      "pushSection": "Pushmelding",
      "pushSubject": "Pushonderwerp",
      "pushBody": "Pushinhoud",
      "overrideNotificationTemplate": "Bestaand sjabloon overschrijven",
      "add": "Sjabloon toevoegen",
      "edit": "Sjabloon bewerken",
      "delete": {
        "title": "Sjabloon verwijderen",
        "text": "Weet u zeker dat u het sjabloon \"{name}\" wilt verwijderen?"
      },
      "attachment": {
        "title": "Bestand bijvoegen",
        "attachment": "Bijlage",
        "attach": "Bijvoegen",
        "noAttachedFile": "Geen bijlage toegevoegd...",
        "messages": {
          "uploadedSuccessfully": "Bijlage succesvol geüpload."
        },
        "delete": {
          "title": "Bijlage verwijderen",
          "text": "Weet u zeker dat u de bijlage \"{name}\" wilt verwijderen?"
        }
      },
      "messages": {
        "created": "Meldingssjabloon succesvol aangemaakt.",
        "updated": "Meldingssjabloon succesvol bijgewerkt.",
        "deleted": "Meldingssjabloon succesvol verwijderd.",
        "alreadyExists": "Er bestaat al een meldingssjabloon met deze naam.",
        "fileRequired": "Het bestand is verplicht.",
        "importError": "Er is een fout opgetreden bij het importeren van het meldingssjabloon.",
        "notFound": "Meldingssjabloon niet gevonden."
      }
    },
    "department": {
      "menuName": "Afdeling",
      "pageTitle": "Afdeling",
      "externalId": "Extern ID",
      "name": "Naam",
      "isActive": "Actief",
      "add": "Afdeling toevoegen",
      "edit": "Afdeling bewerken",
      "delete": {
        "title": "Afdeling verwijderen",
        "text": "Weet u zeker dat u deze afdeling wilt verwijderen?"
      },
      "messages": {
        "created": "Afdeling succesvol aangemaakt.",
        "updated": "Afdeling succesvol bijgewerkt.",
        "deleted": "Afdeling succesvol verwijderd."
      }
    },
    "businessArea": {
      "menuName": "Bedrijfsgebied",
      "pageTitle": "Bedrijfsgebied",
      "id": "Id",
      "externalId": "Extern ID",
      "description": "Beschrijving",
      "calendarId": "Kalender",
      "isActive": "Actief",
      "edit": "Bedrijfsgebied bewerken",
      "messages": {
        "created": "Bedrijfsgebied succesvol aangemaakt.",
        "updated": "Bedrijfsgebied succesvol bijgewerkt.",
        "deleted": "Bedrijfsgebied succesvol verwijderd."
      }
    },
    "businessUnit": {
      "menuName": "Bedrijfsonderdeel",
      "pageTitle": "Bedrijfsonderdeel",
      "id": "Id",
      "externalId": "Extern ID",
      "description": "Beschrijving",
      "isActive": "Actief",
      "edit": "Bedrijfsonderdeel bewerken",
      "messages": {
        "created": "Bedrijfsonderdeel succesvol aangemaakt.",
        "updated": "Bedrijfsonderdeel succesvol bijgewerkt.",
        "deleted": "Bedrijfsonderdeel succesvol verwijderd.",
        "inUse": "Het bedrijfsonderdeel wordt gebruikt. Verwijder eerst het gebruik ervan.",
        "notFound": "Bedrijfsonderdeel niet gevonden"
      },
      "add": "Bedrijfsonderdeel toevoegen",
      "delete": {
        "title": "Bedrijfsonderdeel verwijderen",
        "text": "Weet u zeker dat u dit bedrijfsonderdeel wilt verwijderen?"
      }
    },
    "division": {
      "menuName": "Divisie",
      "pageTitle": "Divisie",
      "id": "Id",
      "externalId": "Extern ID",
      "description": "Beschrijving",
      "isActive": "Actief",
      "businessUnitId": "Bedrijfsonderdeel",
      "edit": "Divisie bewerken",
      "messages": {
        "created": "Divisie succesvol aangemaakt.",
        "updated": "Divisie succesvol bijgewerkt.",
        "deleted": "Divisie succesvol verwijderd."
      },
      "add": "Divisie toevoegen",
      "delete": {
        "title": "Divisie verwijderen",
        "text": "Weet u zeker dat u deze divisie wilt verwijderen?"
      }
    },
    "organization": {
      "menuName": "Organisatie",
      "pageTitle": "Organisatie",
      "id": "Id",
      "externalId": "Extern ID",
      "name": "Naam",
      "plantAreaId": "Vestigingsgebied",
      "organizationParentId": "Bovenliggende organisatie",
      "edit": "Organisatie bewerken",
      "messages": {
        "created": "Organisatie succesvol aangemaakt.",
        "updated": "Organisatie succesvol bijgewerkt.",
        "deleted": "Organisatie succesvol verwijderd."
      },
      "add": "Organisatie toevoegen",
      "delete": {
        "title": "Organisatie verwijderen",
        "text": "Weet u zeker dat u deze organisatie wilt verwijderen?"
      }
    },
    "plant": {
      "menuName": "Vestiging",
      "pageTitle": "Vestiging",
      "id": "Id",
      "name": "Naam",
      "alias": "Alias",
      "isActive": "Actief",
      "divisionId": "Divisie",
      "countryId": "Land",
      "employeeCanUpdateGoals": "Werknemer kan doelen bijwerken",
      "employeeCanUpdateTracks": "Werknemer kan realisaties bijwerken",
      "employeeCanIncludeKPI": "Werknemer kan KPI aanmaken",
      "managerCanUpdateGoals": "Manager kan doelen bijwerken",
      "managerCanUpdateTracks": "Manager kan realisaties bijwerken",
      "managerCanIncludeKPI": "Manager kan KPI aanmaken",
      "edit": "Vestiging bewerken",
      "messages": {
        "created": "Vestiging succesvol aangemaakt.",
        "updated": "Vestiging succesvol bijgewerkt.",
        "deleted": "Vestiging succesvol verwijderd.",
        "inUse": "De vestiging wordt gebruikt. Verwijder eerst het gebruik ervan.",
        "notFound": "Vestiging niet gevonden",
        "duplicated": "Er bestaat al een vestiging met deze alias."
      },
      "add": "Vestiging toevoegen",
      "delete": {
        "title": "Vestiging verwijderen",
        "text": "Weet u zeker dat u deze vestiging wilt verwijderen?"
      }
    },
    "personnelArea": {
      "menuName": "Personeelsgebied",
      "pageTitle": "Personeelsgebied",
      "id": "Id",
      "description": "Beschrijving",
      "externalId": "Extern ID",
      "plantId": "Vestiging",
      "isActive": "Actief",
      "sourceModifiedDate": "Brondatum wijziging",
      "edit": "Personeelsgebied bewerken",
      "messages": {
        "created": "Personeelsgebied succesvol aangemaakt.",
        "updated": "Personeelsgebied succesvol bijgewerkt.",
        "deleted": "Personeelsgebied succesvol verwijderd.",
        "inUse": "Het personeelsgebied wordt gebruikt. Verwijder eerst het gebruik ervan.",
        "notFound": "Personeelsgebied niet gevonden",
        "alreadyExists": "Er bestaat al een personeelsgebied met deze beschrijving.",
        "fileRequired": "Het bestand is verplicht.",
        "importError": "Er is een fout opgetreden bij het importeren van het personeelsgebied.",
        "invalidPlant": "Ongeldig vestigings-ID",
        "duplicateExternalId": "Extern ID is gedupliceerd",
        "importSuccess": "Personeelsgebied succesvol geïmporteerd. U ontvangt het bestand per e-mail",
        "exportSuccess": "Personeelsgebied succesvol geëxporteerd. U ontvangt het bestand per e-mail",
        "exportFailed": "Het exporteren van het personeelsgebied is mislukt.",
        "importFailed": "Het importeren van het personeelsgebied is mislukt.",
        "personNotFound": "Persoon niet gevonden om de import uit te voeren. Neem contact op met de beheerder.",
        "emailNotFound": "E-mailadres niet gevonden om de import uit te voeren. Neem contact op met de beheerder.",
        "importFalied": "Import van personeelsgebied mislukt."
      },
      "add": "Personeelsgebied toevoegen",
      "delete": {
        "title": "Personeelsgebied verwijderen",
        "text": "Weet u zeker dat u dit personeelsgebied wilt verwijderen?"
      }
    },
    "position": {
      "menuName": "Functie",
      "pageTitle": "Functie",
      "id": "Id",
      "description": "Beschrijving",
      "externalId": "Extern ID",
      "active": "Actief",
      "jobCode": "Functie",
      "jobId": "Functie",
      "organizationId": "Organisatie",
      "employeeSubGroupId": "Werknemerssubgroep",
      "costCenterId": "Kostenplaats",
      "salaryLevelId": "Salarisniveau",
      "businessAreaId": "Bedrijfsgebied",
      "bonusFrequencyId": "Bonusfrequentie",
      "personnelAreaCode": "Personeelsgebied",
      "payGradeType": "Salarisschaaltype",
      "payGradeArea": "Salarisschaalgebied",
      "employeeGroupId": "Werknemersgroep",
      "salaryGroupId": "Salarisgroep",
      "minimum": "Minimum",
      "midpoint": "Middenpunt",
      "edit": "Functiegebied bewerken",
      "messages": {
        "created": "Functie succesvol aangemaakt.",
        "updated": "Functie succesvol bijgewerkt.",
        "inUse": "De functie wordt gebruikt. Verwijder eerst het gebruik ervan.",
        "notFound": "Functie niet gevonden",
        "duplicated": "Er bestaat al een functie met dit externe ID/deze naam."
      },
      "add": "Functie toevoegen"
    },
    "configuration": {
      "menuName": "Configuratie",
      "pageTitle": "Configuratie",
      "key": "Sleutel",
      "value": "Waarde",
      "editorType": "Type",
      "add": "Configuratie toevoegen",
      "edit": "Configuratie bewerken",
      "delete": {
        "title": "Configuratie verwijderen",
        "text": "Weet u zeker dat u deze configuratie wilt verwijderen?"
      },
      "messages": {
        "created": "Configuratie succesvol aangemaakt.",
        "updated": "Configuratie succesvol bijgewerkt.",
        "deleted": "Configuratie succesvol verwijderd."
      },
      "types": {
        "text": "Tekst",
        "string": "Tekenreeks",
        "number": "Getal",
        "int": "Geheel getal",
        "boolean": "Booleaans"
      }
    },
    "positionProfile": {
      "pageTitle": "Kritieke functie",
      "globalCritical": "Wereldwijd kritiek",
      "countryCritical": "Land kritiek",
      "businessUnitCritical": "Bedrijfsonderdeel kritiek",
      "positionType": "Functietype",
      "sucessorType": "Opvolgertype",
      "potentialSuccessorType": "Opvolgertype",
      "potentialSuccessorId": "Potentiële opvolger",
      "readinessFactor": "Gereedheidsfactor",
      "potentialSuccessorName": "Naam",
      "potentialSuccessorCompany": "Bedrijf",
      "potentialSuccessorLinkedIn": "LinkedIn-URL",
      "potentialSuccessorNotes": "Notities",
      "messages": {
        "created": "Kritieke functie succesvol aangemaakt.",
        "updated": "Kritieke functie succesvol bijgewerkt."
      }
    },
    "widget": {
      "menuName": "Widget",
      "pageTitle": "Widget",
      "name": "Naam",
      "description": "Beschrijving",
      "securityResources": "Beveiligingsbronnen",
      "link": "Link",
      "query": "SQL-query",
      "queryRequired": "SQL-query is verplicht.",
      "sqlQueryDateFormatInfo": "Datumkolommen moeten worden opgemaakt in het formaat mm/DD/jjjj.",
      "minHeight": "Minimale hoogte",
      "minWidth": "Minimale breedte",
      "autoApplied": "Toepassen op alle dashboards",
      "autoAppliedHelp": "Dit dwingt deze widget af op alle dashboards, en gebruikers blijven deze zien, ook als ze proberen deze te verwijderen.",
      "type": "Type",
      "category": "Categorie",
      "add": "Widget toevoegen",
      "edit": "Widget bewerken",
      "delete": {
        "title": "Widget verwijderen",
        "text": "Weet u zeker dat u deze widget wilt verwijderen?"
      },
      "examples": {
        "viewSQLExamples": "SQL-voorbeelden bekijken",
        "general": "Algemeen",
        "generalDescription": "Standaard biedt het systeem de volgende parameters, die rechtstreeks kunnen worden gebruikt in elke SQL-query van een widget.",
        "loggedUserNameDescription": "Gebruikersnaam waarmee de huidige gebruiker is ingelogd (bijvoorbeeld: {email}).",
        "loggedUserEmployeeIdDescription": "Werknemer-ID van de momenteel ingelogde gebruiker.",
        "loggedUserLanguageDescription": "Taalcode van de momenteel ingelogde gebruiker (bijvoorbeeld: en-US, pt-BR).",
        "loggedUserUniqueIdDescription": "Unieke id van de gebruiker (Guid)",
        "loggedUserEncryptedUniqueIdDescription": "Versleutelde unieke id van de gebruiker",
        "listDescription": "Elke rij vertegenwoordigt één lijstitem.",
        "numberDescription": "Retourneert één numerieke waarde.",
        "donutDescription": "Labels en waarden moeten overeenkomen op positie.",
        "lineDescription": "Elke rij vertegenwoordigt één lijnreeks."
      },
      "messages": {
        "created": "Widget succesvol aangemaakt.",
        "updated": "Widget succesvol bijgewerkt.",
        "deleted": "Widget succesvol verwijderd.",
        "fileRequired": "Het bestand is verplicht.",
        "importError": "Er is een fout opgetreden bij het importeren van de widget.",
        "queryVariablesMissing": "De volgende variabelen ontbreken in de widgetquery: \"{variables}\". Voeg ze toe aan de query om de juiste werking te garanderen."
      }
    },
    "reportColumnTemplate": {
      "menuName": "Rapportkolomsjablonen",
      "pageTitle": "Rapportkolomsjablonen",
      "id": "ID",
      "description": "Beschrijving",
      "template": "Sjabloon",
      "templateHelp": "Gebruik {value} als tijdelijke aanduiding voor de celwaarde. HTML wordt ondersteund.",
      "add": "Sjabloon toevoegen",
      "edit": "Sjabloon bewerken",
      "delete": {
        "title": "Sjabloon verwijderen",
        "text": "Weet u zeker dat u \"{name}\" wilt verwijderen?"
      },
      "messages": {
        "created": "Sjabloon succesvol aangemaakt.",
        "updated": "Sjabloon succesvol bijgewerkt.",
        "deleted": "Sjabloon succesvol verwijderd."
      }
    },
    "widgetCategory": {
      "menuName": "Widgetcategorie",
      "pageTitle": "Widgetcategorie",
      "name": "Naam",
      "description": "Beschrijving",
      "type": "Type",
      "add": "Widgetcategorie toevoegen",
      "edit": "Widgetcategorie bewerken",
      "delete": {
        "title": "Widgetcategorie verwijderen",
        "text": "Weet u zeker dat u deze widgetcategorie wilt verwijderen?"
      },
      "messages": {
        "created": "Widgetcategorie succesvol aangemaakt.",
        "updated": "Widgetcategorie succesvol bijgewerkt.",
        "deleted": "Widgetcategorie succesvol verwijderd."
      }
    },
    "widgetType": {
      "menuName": "Widgettype",
      "pageTitle": "Widgettype",
      "name": "Naam",
      "types": {
        "number": "Getal",
        "list": "Lijst",
        "donut": "Donut",
        "line": "Lijn"
      }
    },
    "widgetParameter": {
      "menuName": "Widgetparameter",
      "menuTitle": "Widgetparameter",
      "title": "Widgetparameter",
      "name": "Naam",
      "nameInfo": "Naam die wordt gebruikt om de parameter te identificeren in de SQL-query van de widget. Gebruik geen spaties of speciale tekens.",
      "nameUniqueError": "Er bestaat al een widgetparameter met deze naam.",
      "description": "Beschrijving",
      "isRequired": "Verplicht?",
      "isMultiple": "Meerdere waarden?",
      "status": "Status",
      "edit": "Widgetparameter bewerken",
      "add": "Widgetparameter toevoegen",
      "type": "Type",
      "data": "SQL-query",
      "dataInfo": "De SQL-query moet twee kolommen retourneren met de namen 'Value' en 'Text'.",
      "listOfValues": "Lijst met waarden",
      "addValue": "Waarde toevoegen",
      "value": "Waarde",
      "label": "Label",
      "delete": {
        "title": "Widgetparameter verwijderen",
        "text": "Weet u zeker dat u {name} wilt verwijderen?"
      },
      "types": {
        "text": "Tekst",
        "number": "Getal",
        "date": "Datum",
        "boolean": "Booleaans",
        "select": "Lijst",
        "sql": "Querylijst"
      },
      "messages": {
        "notFound": "Widgetparameter niet gevonden.",
        "saveSuccess": "Widgetparameter succesvol opgeslagen.",
        "saveError": "Er is een fout opgetreden bij het opslaan van de widgetparameter.",
        "deleteSuccess": "Widgetparameter succesvol verwijderd.",
        "deleteError": "Er is een fout opgetreden bij het verwijderen van de widgetparameter.",
        "isInUse": "Kan widgetparameter niet verwijderen omdat deze in gebruik is."
      }
    },
    "people": {
      "menuName": "Personen",
      "pageTitle": "Personen",
      "edit": "Persoon bewerken",
      "employeeId": "Werknemer-ID",
      "person": "Persoon",
      "id": "Id",
      "name": "Naam",
      "email": "E-mail",
      "externalId": "Extern ID",
      "status": "Status",
      "type": "Type",
      "positionShortDescription": "Korte functiebeschrijving",
      "hireDate": "Indiensttredingsdatum",
      "culture": "Cultuur",
      "sourceJTPInstance": "Bron-JTP-code",
      "documentId": "Document-ID",
      "manager": "Manager",
      "position": "Functie",
      "bonusFrequency": "Bonusfrequentie",
      "businessArea": "Bedrijfsgebied",
      "personnelArea": "Personeelsgebied",
      "division": "Divisie",
      "plant": "Vestiging",
      "businessUnit": "Bedrijfsonderdeel",
      "shiftId": "Dienst",
      "plantAreaId": "Vestigingsgebied",
      "immigrationTypeId": "Immigratietype",
      "customerSpecificStatus": "Klantspecifieke status",
      "vendorNumber": "Leveranciersnummer",
      "accountNumber": "Laatste 4 cijfers rekeningnummer",
      "overrideManagerId": "Manager overschrijven",
      "saipAllocation": "SAIP-toewijzing",
      "requirePrivacyConsent": "Wereldwijde werknemer",
      "globalDirectReports": "Wereldwijde directe rapportagelijnen",
      "globalManagerOverrideHelpText": "Geselecteerde werknemers rapporteren alleen op wereldwijd niveau aan deze werknemer. Als deze werknemer directe rapportagelijnen heeft, worden alle directe rapportagelijnen ook als wereldwijd gemarkeerd",
      "messages": {
        "updated": "Persoon succesvol bijgewerkt.",
        "notFound": "Persoon niet gevonden",
        "alreadyExists": "Er bestaat al een persoon met deze beschrijving.",
        "fileRequired": "Het bestand is verplicht.",
        "importError": "Er is een fout opgetreden bij het importeren van de personen.",
        "importSuccess": "Personen succesvol geïmporteerd. U ontvangt het bestand per e-mail",
        "importFailed": "Het importeren van personen is mislukt.",
        "personNotFound": "Persoon niet gevonden om de import uit te voeren. Neem contact op met de beheerder.",
        "emailNotFound": "E-mailadres niet gevonden om de import uit te voeren. Neem contact op met de beheerder.",
        "importFalied": "Import van personen mislukt."
      },
      "personTypes": {
        "unknown": "Onbekend",
        "salariedEmployee": "Salariswerknemer",
        "contractor": "Aannemer",
        "vendor": "Leverancier",
        "hourlyEmployee": "Uurloonwerknemer",
        "external": "Extern",
        "duHourlyInactive": "DU Uurloon Inactief",
        "duSalariedInactive": "DU Salaris Inactief",
        "duTruckDriverIn": "DU Vrachtwagenchauffeur In",
        "executive": "Directielid",
        "union": "Vakbond",
        "nonUnion": "Geen vakbond",
        "unionPossible": "Mogelijk vakbond",
        "salariedNonExempt": "Salaris Niet-vrijgesteld",
        "hourly": "Uurloon",
        "duPaidLeave": "DU Betaald Verlof",
        "truckDriver": "Vrachtwagenchauffeur",
        "duUnpaidLeave": "DU Onbetaald Verlof",
        "workRelease": "Werkvrijstelling",
        "externalAccessLevelOne": "Externe toegang niveau één",
        "externalAccessLevelTwo": "Externe toegang niveau twee",
        "externalAccessLevelThree": "Externe toegang niveau drie",
        "externalAccessLevelFour": "Externe toegang niveau vier",
        "externalAccessLevelFive": "Externe toegang niveau vijf",
        "globalEmployee": "Wereldwijde werknemer"
      },
      "customerSpecificStatuses": {
        "unknown": "Onbekend",
        "active": "Actief",
        "inactive": "Inactief",
        "incomeAssistance": "Inkomensondersteuning",
        "lOA": "Verlof",
        "retiree": "Gepensioneerd",
        "withdrawn": "Ingetrokken"
      }
    },
    "companyCode": {
      "menuName": "Bedrijfscodes"
    },
    "costCenter": {
      "menuName": "Kostenplaatsen"
    },
    "currency": {
      "menuName": "Valuta's"
    },
    "exchangeRate": {
      "menuName": "Wisselkoersen"
    }
  },
  "threeHundredSixty": {
    "menuTitle": "360",
    "questionOption": {
      "menuTitle": "Beoordelingsschalen",
      "pageTitle": "Beoordelingsschalen",
      "description": "Beschrijving",
      "add": "Beoordelingsschaal toevoegen",
      "edit": "Beoordelingsschaal bewerken",
      "delete": {
        "title": "Beoordelingsschaal verwijderen",
        "text": "Weet u zeker dat u deze beoordelingsschaal wilt verwijderen?"
      },
      "messages": {
        "notFound": "Beoordelingsschaal niet gevonden.",
        "saveSuccess": "Beoordelingsschaal succesvol opgeslagen.",
        "saveError": "Er is een fout opgetreden bij het opslaan van de beoordelingsschaal.",
        "deleteSuccess": "Beoordelingsschaal succesvol verwijderd.",
        "deleteError": "Er is een fout opgetreden bij het verwijderen van de beoordelingsschaal.",
        "isInUse": "Kan beoordelingsschaal niet verwijderen omdat deze in gebruik is.",
        "duplicateName": "Er bestaat al een beoordelingsschaal met deze beschrijving."
      },
      "options": {
        "title": "Opties",
        "value": "Waarde",
        "description": "Beschrijving",
        "explanation": "Toelichting",
        "itemOrder": "Volgorde",
        "color": "Kleur",
        "commentConfig": "Opmerkingenconfiguratie",
        "add": "Optie toevoegen",
        "edit": "Optie bewerken",
        "delete": {
          "title": "Optie verwijderen",
          "text": "Weet u zeker dat u deze optie wilt verwijderen?"
        },
        "messages": {
          "created": "Optie succesvol aangemaakt.",
          "updated": "Optie succesvol bijgewerkt.",
          "deleted": "Optie succesvol verwijderd.",
          "notFound": "Optie niet gevonden.",
          "duplicateValue": "Twee of meer opties hebben dezelfde waarde. Elke optie moet een unieke waarde hebben.",
          "duplicateDescription": "Twee of meer opties hebben dezelfde beschrijving. Elke optie moet een unieke beschrijving hebben."
        },
        "commentConfigType": {
          "followForm": "Formulier volgen",
          "required": "Verplicht",
          "notRequired": "Niet verplicht"
        }
      }
    },
    "questionGroup": {
      "menuTitle": "Vraaggroepen",
      "pageTitle": "Vraaggroepen",
      "name": "Naam",
      "description": "Beschrijving",
      "add": "Vraaggroep toevoegen",
      "edit": "Vraaggroep bewerken",
      "delete": {
        "title": "Vraaggroep verwijderen",
        "text": "Weet u zeker dat u deze vraaggroep wilt verwijderen: {name}?"
      },
      "messages": {
        "notFound": "Vraaggroep niet gevonden.",
        "saveSuccess": "Vraaggroep succesvol opgeslagen.",
        "saveError": "Er is een fout opgetreden bij het opslaan van de vraaggroep.",
        "deleteSuccess": "Vraaggroep succesvol verwijderd.",
        "deleteError": "Er is een fout opgetreden bij het verwijderen van de vraaggroep.",
        "isInUse": "Kan vraaggroep niet verwijderen omdat deze in gebruik is."
      }
    },
    "question": {
      "menuTitle": "Vragen",
      "pageTitle": "Vragen",
      "name": "Naam",
      "weight": "Gewicht",
      "commentDisabled": "Opmerking uitgeschakeld",
      "description": "Beschrijving",
      "questionGroup": "Vraaggroep",
      "questionOption": "Beoordelingsschaal",
      "add": "Vraag toevoegen",
      "edit": "Vraag bewerken",
      "delete": {
        "title": "Vraag verwijderen",
        "text": "Weet u zeker dat u deze vraag wilt verwijderen?"
      },
      "messages": {
        "notFound": "Vraag niet gevonden.",
        "saveSuccess": "Vraag succesvol opgeslagen.",
        "saveError": "Er is een fout opgetreden bij het opslaan van de vraag.",
        "deleteSuccess": "Vraag succesvol verwijderd.",
        "deleteError": "Er is een fout opgetreden bij het verwijderen van de vraag.",
        "isInUse": "Kan vraag niet verwijderen omdat deze in gebruik is."
      }
    },
    "formCategory": {
      "menuTitle": "Formuliercategorieën",
      "pageTitle": "Formuliercategorieën",
      "name": "Naam",
      "description": "Beschrijving",
      "add": "Formuliercategorie toevoegen",
      "edit": "Formuliercategorie bewerken",
      "delete": {
        "title": "Formuliercategorie verwijderen",
        "text": "Weet u zeker dat u deze formuliercategorie wilt verwijderen?"
      },
      "messages": {
        "notFound": "Formuliercategorie niet gevonden.",
        "saveSuccess": "Formuliercategorie succesvol opgeslagen.",
        "saveError": "Er is een fout opgetreden bij het opslaan van de formuliercategorie.",
        "deleteSuccess": "Formuliercategorie succesvol verwijderd.",
        "deleteError": "Er is een fout opgetreden bij het verwijderen van de formuliercategorie.",
        "isInUse": "Kan formuliercategorie niet verwijderen omdat deze in gebruik is."
      }
    },
    "formDelegate": {
      "menuTitle": "Formulierafgevaardigde",
      "pageTitle": "Formulierafgevaardigde",
      "form": "Formulier",
      "manager": "Manager",
      "delegate": "Afgevaardigde",
      "add": "Formulierafgevaardigde toevoegen",
      "edit": "Formulierafgevaardigde bewerken",
      "delegatedToPerson": "Afvaardigen aan",
      "invitedEnabled": "Uitnodigen ingeschakeld",
      "signEnabled": "Ondertekenen ingeschakeld",
      "resultViewerEnabled": "Resultatenviewer ingeschakeld",
      "delete": {
        "title": "Formulierafgevaardigde verwijderen",
        "text": "Weet u zeker dat u deze formulierafgevaardigde wilt verwijderen?"
      },
      "messages": {
        "notFound": "Formulierafgevaardigde niet gevonden.",
        "saveSuccess": "Formulierafgevaardigde succesvol opgeslagen.",
        "saveError": "Er is een fout opgetreden bij het opslaan van de formulierafgevaardigde.",
        "deleteSuccess": "Formulierafgevaardigde succesvol verwijderd.",
        "deleteError": "Er is een fout opgetreden bij het verwijderen van de formulierafgevaardigde.",
        "managerDisabledMessage": "U heeft geen toegang tot dit formulier"
      }
    },
    "formDelegateGlobal": {
      "menuTitle": "Globale formulierafgevaardigde",
      "pageTitle": "Globale formulierafgevaardigde"
    },
    "form": {
      "menuTitle": "Formulieren",
      "pageTitle": "Formulieren",
      "id": "Id",
      "description": "Beschrijving",
      "category": "Categorie",
      "categoryId": "Categorie",
      "stage": {
        "label": "Fase",
        "preparation": "Voorbereiding",
        "execution": "Uitvoering",
        "managerReview": "Managerbeoordeling",
        "participantReview": "Deelnemersbeoordeling",
        "closed": "Gesloten"
      },
      "active": "Actief",
      "maximumHireDate": "Maximale indiensttredingsdatum",
      "maxPeopleEvaluateAlert": "Waarschuwing max. aantal te beoordelen personen",
      "includeGlobalReporting": "Wereldwijde rapportage",
      "customerSpecificStatus": "Klantspecifieke status",
      "employeeType": "Type werknemer",
      "reportType": {
        "label": "Rapporttype",
        "question": "Per vraag",
        "questionGroup": "Per vraaggroep"
      },
      "directReportBox": "Directe rapportagelijn",
      "selfEvaluationBox": "Zelfevaluatie",
      "managerEvaluationBox": "Managerevaluatie",
      "crossGroupEvaluationBox": "Cross-groepevaluatie",
      "freeEvaluationBox": "Vrije evaluatie",
      "dueDatesBox": "Vervaldatums",
      "evaluation": "Evaluatie",
      "comments": "Opmerkingen",
      "weight": "Gewicht",
      "minCrossGroupEvaluations": "Min. cross-groepevaluaties",
      "crossGroupDueDate": "Cross-groep aanmaken – Zelf",
      "evaluationDueDate": "Cross-groep aanmaken – Manager",
      "managerSignDueDate": "Definitieve cross-groep – Manager",
      "participantSignDueDate": "Sluitingsdatum",
      "processDueDate": "Evaluatie",
      "beginningReviewDate": "Begin beoordelingsperiode",
      "endingReviewDate": "Einde beoordelingsperiode",
      "maxReleaseQuestionnaireDate": "Vragenlijst vrijgeven",
      "createdBy": "Aangemaakt door",
      "createdDate": "Aanmaakdatum",
      "modifiedBy": "Gewijzigd door",
      "modifiedDate": "Wijzigingsdatum",
      "maximumHireDateHelpText": "Maximale indiensttredingsdatum van de werknemer om deel te nemen, tenzij de werknemer een manager is.",
      "maxPeopleEvaluateAlertHelpText": "Toon een waarschuwing zodra de werknemer het maximale aantal te beoordelen personen bereikt",
      "includeGlobalReportingHelpText": "Opnemen in wereldwijde rapportage",
      "directReportEvaluationHelpText": "Evaluatie directe rapportagelijn",
      "directReportCommentsHelpText": "Opmerkingen directe rapportagelijn",
      "directReportWeightHelpText": "Gewicht directe rapportagelijn",
      "selfEvaluationHelpText": "Zelfevaluatie",
      "selfCommentsHelpText": "Eigen opmerkingen",
      "selfWeightHelpText": "Eigen gewicht",
      "managerEvaluationHelpText": "Managerevaluatie",
      "managerCommentsHelpText": "Manageropmerkingen",
      "managerWeightHelpText": "Managergewicht",
      "freeCommentsHelpText": "Vrije opmerkingen",
      "freeWeightHelpText": "Vrij gewicht",
      "crossGroupEvaluationHelpText": "Cross-groepevaluatie",
      "crossGroupCommentsHelpText": "Cross-groepopmerkingen",
      "crossGroupWeightHelpText": "Cross-groepgewicht",
      "minCrossGroupEvaluationsHelpText": "Minimumaantal cross-groepevaluaties waarmee de manager de vragenlijst mag vrijgeven.",
      "maxReleaseQuestionnaireDateHelpText": "Maximale datum voor de manager om de vragenlijst vrij te geven",
      "add": "Formulier toevoegen",
      "edit": "Formulier bewerken",
      "updateCounters": "Tellers bijwerken",
      "detailedResult": "Gedetailleerd resultaat",
      "move": {
        "button": "Verplaatsen naar {stage}",
        "title": "Stap verplaatsen",
        "text": "Weet u zeker dat u dit formulier wilt verplaatsen naar fase {stage}?"
      },
      "duplicate": {
        "button": "Dupliceren",
        "title": "Formulier dupliceren",
        "text": "Weet u zeker dat u dit formulier wilt dupliceren?"
      },
      "delete": {
        "title": "Formulier verwijderen",
        "text": "Weet u zeker dat u dit formulier wilt verwijderen: {name}?"
      },
      "formQuestion": {
        "title": "Formuliervragen",
        "question": "Vraag",
        "itemOrder": "Volgorde",
        "questionGroup": "Vraaggroep",
        "add": "Vraag toevoegen",
        "edit": "Vraag bewerken",
        "delete": {
          "title": "Vraag verwijderen",
          "text": "Weet u zeker dat u {name} van dit formulier wilt verwijderen?"
        },
        "messages": {
          "saveSuccess": "Formuliervraag succesvol opgeslagen.",
          "saveError": "Er is een fout opgetreden bij het opslaan van de formuliervraag.",
          "deleteSuccess": "Formuliervraag succesvol verwijderd.",
          "deleteError": "Er is een fout opgetreden bij het verwijderen van de formuliervraag.",
          "duplicateQuestion": "Deze vraag is al toegevoegd aan het formulier.",
          "notFound": "Formuliervraag niet gevonden.",
          "questionNotFound": "Vraag niet gevonden."
        }
      },
      "messages": {
        "notFound": "Formulier niet gevonden.",
        "saveSuccess": "Formulier succesvol opgeslagen.",
        "saveError": "Er is een fout opgetreden bij het opslaan van het formulier.",
        "deleteSuccess": "Formulier succesvol verwijderd.",
        "deleteError": "Er is een fout opgetreden bij het verwijderen van het formulier.",
        "deleteNotAllowed": "Kan geen formulier verwijderen dat zich niet in de fase Voorbereiding bevindt.",
        "isInUse": "Kan formulier niet verwijderen omdat het in gebruik is.",
        "atLeastOneMemberEvaluate": "Ten minste één type beoordelaar (directe rapportagelijn, zelf, manager of cross-groep) moet zijn ingeschakeld.",
        "maximumHireDateRequired": "Maximale indiensttredingsdatum is verplicht.",
        "dueDatesRequired": "Alle vervaldatums zijn verplicht.",
        "moveStageSuccess": "Formulier succesvol verplaatst naar de volgende fase.",
        "moveStageNotAllowed": "Kan een gesloten formulier niet naar een andere fase verplaatsen.",
        "moveStageNotAllowedNoPeople": "Het formulier heeft geen personen. Ga naar de pagina Formulierdeelnemers om personen aan dit formulier toe te voegen.",
        "moveStageNotAllowedNoQuestions": "Het formulier heeft geen vragen. Voeg ten minste één vraag toe om het te kunnen verplaatsen.",
        "duplicateSuccess": "Formulier succesvol gedupliceerd.",
        "updateCountersSuccess": "Het bijwerken van de tellers is gestart.",
        "detailedResultSuccess": "Het genereren van het gedetailleerde resultaat is gestart."
      }
    },
    "formEmailSender": {
      "menuTitle": "Formulier e-mailverzender",
      "pageTitle": "Formulier e-mailverzender",
      "messages": {
        "emailsSent": "E-mails succesvol verzonden."
      }
    },
    "questionnaire": {
      "questionnaireTypes": {
        "manager": "Manager",
        "directReport": "Directe rapportagelijn",
        "crossGroup": "Cross-groep",
        "selfEvaluation": "Zelfevaluatie",
        "freeEvaluation": "Vrije evaluatie"
      },
      "questionnaireRequestTypes": {
        "default": "Standaard",
        "manager": "Manager",
        "directReport": "Directe rapportagelijn"
      },
      "questionnaireStatus": {
        "done": "Voltooid",
        "declined": "Geweigerd",
        "open": "Open"
      },
      "questionnairePriorityTypes": {
        "selfDirectManager": "Zelf, directe rapportagelijnen en manager",
        "crossGroupPeers": "Cross-groep (collega's)",
        "crossGroup": "Cross-groepen",
        "freeEvaluation": "Vrije evaluatie"
      },
      "questionnairesReport": {
        "title": "Vragenlijstenrapport",
        "messages": {
          "confirm": "Het bestand wordt geëxporteerd. U ontvangt de resultaten binnenkort per e-mail.",
          "success": "Het exporteren van het vragenlijstenrapport is gestart. U ontvangt de resultaten binnenkort per e-mail.",
          "emailNotFound": "E-mailadres niet gevonden om de export uit te voeren. Neem contact op met de beheerder.",
          "formNotFound": "Formulier niet gevonden om de export uit te voeren. Neem contact op met de beheerder.",
          "exportFailed": "Het exporteren van het vragenlijstenrapport is mislukt."
        }
      },
      "createCrossGroupForMyself": {
        "menuTitle": "Cross-groep voor mezelf aanmaken",
        "pageTitle": "Cross-groep voor mezelf aanmaken",
        "form": "Formulier",
        "infoMessage": " Hieronder ziet u uw standaard cross-groep. Voeg extra werknemers toe door wie u beoordeeld wilt worden. U moet ten minste vijf personen hebben met het type \"cross-groep\". Uw manager beoordeelt dit, werkt het zo nodig bij en geeft de vragenlijsten vrij.",
        "warningReleasedQuestionnaires": "U kunt geen cross-groepen toevoegen omdat uw manager al vragenlijsten over u heeft vrijgegeven. Overleg met uw manager over het toevoegen van meer vragenlijsten.",
        "add": "Werknemer toevoegen",
        "evaluatorPerson": "Beoordelaar",
        "manager": "Manager",
        "type": "Type",
        "requestType": "Aangevraagd door",
        "released": "Vrijgegeven",
        "status": "Status",
        "actions": "Acties",
        "delete": {
          "title": "Vragenlijst verwijderen",
          "text": "Weet u zeker dat u deze vragenlijst wilt verwijderen?"
        },
        "messages": {
          "alreadyExists": "Deze vragenlijst bestaat al voor {names}. Neem bij vragen contact op met uw manager.",
          "addSuccess": "Vragenlijsten succesvol aangemaakt.",
          "deleteSuccess": "Vragenlijst succesvol verwijderd.",
          "invitedPersonWarning": "{names} is al uitgenodigd om 360 graden-feedback te geven op ten minste {limit} andere formulieren. Selecteer 'Opslaan' om deze persoon aan aanvullende formulieren toe te voegen. Als de feedback niet essentieel is, sluit dan zonder op te slaan en selecteer een andere persoon om feedback te geven."
        }
      },
      "crossGroupForMyTeam": {
        "menuTitle": "Cross-groepen voor mijn team aanmaken",
        "pageTitle": "Cross-groepen voor mijn team aanmaken",
        "form": "Formulier",
        "manager": "Manager",
        "evaluatedPerson": "Beoordeeld",
        "evaluatorPerson": "Beoordelaar",
        "type": "Type",
        "released": "Vrijgegeven",
        "status": "Status",
        "loadCrossGroupDefaults": "Standaard cross-groep laden",
        "unloadCrossGroupDefaults": "Standaard cross-groep verwijderen",
        "releaseQuestionnaire": "Vragenlijsten vrijgeven",
        "add": "Vragenlijst toevoegen",
        "delete": {
          "title": "Vragenlijst verwijderen",
          "text": "Weet u zeker dat u deze vragenlijst wilt verwijderen?"
        },
        "messages": {
          "alreadyExists": "Deze vragenlijst bestaat al voor {names}. Neem bij vragen contact op met uw manager.",
          "createdSuccess": "Vragenlijsten succesvol aangemaakt.",
          "deletedSuccess": "Vragenlijst succesvol verwijderd.",
          "saveError": "Er is een fout opgetreden bij het opslaan van de vragenlijst. Probeer het opnieuw.",
          "questionnairesAlreadyExists": "Er bestaan al vragenlijsten voor: {names}.",
          "managerDisabledMessage": "U heeft geen toegang tot dit cross-groepformulier",
          "releasedSuccess": "Vragenlijsten succesvol vrijgegeven.",
          "minCrossGroupEvaluations": "Alleen personen met ten minste {value} cross-groepvragenlijsten worden weergegeven.",
          "noQuestionnairesToRelease": "Er zijn geen vragenlijsten om vrij te geven. Voeg ten minste één vragenlijst toe om vrij te geven.",
          "isReadOnlyDueStage": "Dit formulier is alleen-lezen en kan niet worden bewerkt",
          "remoteInstanceWarning": "Er is een probleem opgetreden bij het laden van externe informatie.",
          "minimumCrossGroupsNotMet": "De directe rapportagelijn heeft niet het minimumaantal cross-groepen ({current}/{minimum})",
          "questionnairesReleased": "Vragenlijsten vrijgegeven",
          "readyForRelease": "Klaar voor vrijgave"
        },
        "crossGroupDefaults": {
          "loadDefaults": {
            "title": "Standaard cross-groep laden",
            "messages": {
              "confirm": "WAARSCHUWING: Bevestig dat u de standaard cross-groepdeelnemers wilt laden voor alle directe rapportagelijnen.",
              "success": "Standaard cross-groepdeelnemers succesvol geladen."
            }
          },
          "unloadDefaults": {
            "title": "Standaard cross-groep verwijderen",
            "messages": {
              "confirm": "Bevestig dat u de standaard cross-groepdeelnemers wilt verwijderen voor alle directe rapportagelijnen.",
              "success": "Standaard cross-groepdeelnemers succesvol verwijderd."
            }
          }
        }
      },
      "crossGroupForMyRemoteTeam": {
        "menuTitle": "Cross-groepen voor mijn wereldwijde team aanmaken",
        "pageTitle": "Cross-groepen voor mijn wereldwijde team aanmaken"
      },
      "complete": {
        "menuTitle": "Evaluaties voltooien",
        "pageTitle": "Evaluaties voltooien",
        "form": "Formulier",
        "questionnaireType": "Vragenlijsttype",
        "submit": "Indienen",
        "notApplicable": "N.v.t.",
        "declinedCommentPlaceholder": "Niet van toepassing",
        "reopen": "Heropenen",
        "status": {
          "new": "Vragenlijst niet gestart",
          "inProgress": "Vragenlijst in behandeling",
          "completed": "Vragenlijst voltooid"
        },
        "notApplicableTitle": "Vragenlijst weigeren",
        "reopenTitle": "Terugtrekking bevestigen",
        "addFreeEvaluation": "Vrije evaluatie toevoegen",
        "personToEvaluate": "Te beoordelen persoon",
        "freeEvaluationWarning": "Vrije evaluaties moeten door managers worden goedgekeurd en tellen niet mee in de algehele 360-scores.",
        "messages": {
          "loading": "Vragenlijsten worden geladen...",
          "loadingGlobalQuestionnaires": "Wereldwijde vragenlijsten worden geladen...",
          "formNotFound": "Formulier niet gevonden.",
          "employeeNotFound": "Werknemer niet gevonden.",
          "freeEvaluationNotAllowed": "U kunt geen vrije evaluatie toevoegen voor uzelf, uw manager, uw collega's of uw directe rapportagelijnen.",
          "alreadyExists": "Er bestaat al een evaluatie voor deze persoon.",
          "submitConfirmation": "Door op indienen te klikken, wordt de weergegeven beoordeling van de werknemer vastgelegd. U kunt ingediende evaluaties intrekken totdat het 360-proces overgaat naar managerondertekening.",
          "summaryValidate": "Controleer de antwoorden en scroll naar beneden om in te dienen. Als u op het kruisje rechtsboven klikt, wordt uw indiening niet afgerond.",
          "submitSuccess": "Vragenlijst succesvol ingediend.",
          "questionnaireNotFound": "Vragenlijst niet gevonden.",
          "notSubmittedWarningMessage": "Deze vragenlijst is nog niet ingediend en wordt niet meegenomen in de score van de werknemer.",
          "noQuestionnaires": "U heeft geen vragenlijsten om te voltooien.",
          "selectQuestionnaire": "Selecteer een vragenlijst om te voltooien.",
          "employeeRateSummary": "Beoordeling van werknemer: ",
          "notApplicable": "Als u niet de juiste persoon bent om deze prestatiebeoordeling te voltooien, kunt u de verantwoordelijkheid weigeren nadat u een reden heeft opgegeven.",
          "declineSuccess": "Vragenlijst succesvol geweigerd.",
          "requiredQuestionnairesCompleted": "Alle resterende evaluaties kunnen naar eigen inzicht worden voltooid.",
          "allQuestionsRequired": "Alle vragen en opmerkingen zijn verplicht om te kunnen indienen.",
          "confirmReopen": "Weet u zeker dat u de evaluatie voor {name} wilt terugtrekken?",
          "reopenSuccess": "Vragenlijst succesvol heropend.",
          "questionnaireAlreadySubmitted": "Deze vragenlijst is al ingediend en kan niet meer worden bewerkt.",
          "addFreeEvaluationSuccess": "Vrije evaluatie succesvol toegevoegd."
        }
      },
      "freeEvaluation": {
        "menuTitle": "Beoordeling vrije evaluaties",
        "menuTitleGlobal": "Wereldwijde beoordeling vrije evaluaties",
        "pageTitle": "Beoordeling vrije evaluaties",
        "pageTitleGlobal": "Wereldwijde beoordeling vrije evaluaties",
        "evaluatedPerson": "Beoordeeld",
        "view": "Vragenlijst bekijken",
        "infoMessage": "Bekijk onderstaande vragenlijsten en keur de vragenlijsten goed waarmee u akkoord gaat. Als u een vragenlijst niet goedkeurt, is geen verdere actie vereist.",
        "messages": {
          "confirmApproval": "Weet u zeker dat u de vragenlijst wilt goedkeuren?",
          "approvalSuccess": "Vragenlijst succesvol goedgekeurd.",
          "notFound": "Vragenlijst niet gevonden."
        }
      }
    },
    "formPeople": {
      "participants": {
        "menuTitle": "Formulierdeelnemers",
        "pageTitle": "Formulierdeelnemers",
        "formId": "Formulier",
        "resetTree": "Structuur resetten",
        "resetTreeTitle": "Structuur resetten",
        "resetTreeText": "Weet u zeker dat u de structuur wilt resetten?",
        "addPerson": "Deelnemer toevoegen",
        "changeManager": "Manager wijzigen",
        "moveToAnotherManager": "Verplaatsen naar een andere manager",
        "downloadTemplate": "Sjabloon downloaden",
        "import": "Importeren",
        "person": "Werknemer",
        "currentManager": "Huidige manager",
        "newManager": "Nieuwe manager",
        "messages": {
          "noNodeSelected": "U moet ten minste één werknemer selecteren.",
          "saveSuccess": "Formulierdeelnemers succesvol opgeslagen.",
          "resetSuccess": "Formulierdeelnemers succesvol gereset.",
          "formNotFound": "Formulier niet gevonden.",
          "selectEmployee": "Selecteer eerst een werknemer",
          "addPersonSuccess": "Persoon succesvol toegevoegd.",
          "changeManagerSuccess": "Manager succesvol gewijzigd.",
          "moveToManagerSuccess": "Persoon succesvol verplaatst naar nieuwe manager.",
          "managerNotInTree": "De geselecteerde manager bevindt zich niet in de structuur.",
          "circularManagerSelection": "Kan een werknemer niet verplaatsen naar een van zijn eigen rapportagelijnen.",
          "importSuccess": "Bestand succesvol geïmporteerd. U ontvangt de resultaten binnenkort per e-mail."
        },
        "errors": {
          "formInExecution": "Deze actie kan niet worden uitgevoerd omdat het formulier zich momenteel in uitvoering bevindt."
        }
      },
      "resultViewer": {
        "menuTitle": "Goedgekeurde PDF-rapporten",
        "pageTitle": "Goedgekeurde PDF-rapporten",
        "person": "Persoon",
        "personHelpText": "U kunt uzelf of een van uw directe rapportagelijnen selecteren.",
        "personMultipleInstance": "Selecteer geen werknemers uit meerdere instanties. Resultaten kunnen onjuist of onvolledig zijn.",
        "manager": "Manager",
        "form": "Formulier",
        "position": "Functie",
        "managerFeedback": "Feedback manager",
        "employeeFeedback": "Feedback werknemer",
        "pdfReport": "PDF-rapport",
        "pdfReportFreeEvaluation": "PDF vrije evaluatie",
        "pdfReportFreeEvaluationNonApproved": "PDF niet-goedgekeurde vrije evaluatie",
        "downloadSelected360Report": "Geselecteerd 360-rapport downloaden",
        "downloadSelectedFreeEvaluationReport": "Geselecteerd vrije-evaluatierapport downloaden",
        "downloadSelectedNonApprovedFreeEvaluationReport": "Geselecteerd niet-goedgekeurd vrije-evaluatierapport downloaden",
        "emailSelected360Report": "Geselecteerd 360-rapport downloaden",
        "emailSelectedFreeEvaluationReport": "Geselecteerd vrije-evaluatierapport downloaden",
        "emailSelectedNonApprovedFreeEvaluationReport": "Geselecteerd niet-goedgekeurd vrije-evaluatierapport downloaden",
        "bulkEmailQueued": "Uw rapporten worden voorbereid. U ontvangt binnenkort een e-mail met de PDF-bijlagen.",
        "bulkEmailNoSelection": "Selecteer ten minste één rij.",
        "bulkEmailInvalidSelection": "Een of meer geselecteerde rijen zijn niet geldig voor uw toegang.",
        "bulkEmailNoReportForKind": "De geselecteerde rijen bevatten dit rapporttype niet.",
        "showFeedback": "Feedback tonen",
        "downloadEvaluationSelectOne": "Selecteer een persoon of manager.",
        "validationSelectPersonOrManager": "Selecteer een persoon of manager om het filter uit te voeren.",
        "successPdfByEmail": "De PDF is succesvol naar uw e-mailadres verzonden."
      },
      "sign": {
        "menuTitle": "Openstaande evaluaties ondertekenen",
        "pageTitle": "Openstaande evaluaties ondertekenen",
        "menuTitleGlobal": "Wereldwijde openstaande evaluaties ondertekenen",
        "pageTitleGlobal": "Wereldwijde openstaande evaluaties ondertekenen",
        "form": "Formulier",
        "managerOrPerson": "Manager/Persoon",
        "person": "Persoon",
        "pdfReport": "PDF-rapport",
        "pdfReportFreeEvaluation": "PDF-rapport vrije evaluaties",
        "sign": "Ondertekenen",
        "signed": "Ondertekend",
        "signTitle": "Evaluatie ondertekenen",
        "managerSign": "Ondertekening manager",
        "personSign": "Ondertekening werknemer",
        "signatureComments": "Opmerkingen bij ondertekening",
        "updateComment": "Opmerking bijwerken",
        "messages": {
          "signedBy": "Ondertekend door {name} op {date}",
          "signConfirmationManager": "Hieronder kunt u aanvullende informatie geven over het feedbackgesprek met uw directe rapportagelijn.",
          "signConfirmationPerson": "Door te ondertekenen bevestigt u dat u een feedbackgesprek heeft gehad met uw manager over de evaluatie.",
          "signConfirmationWarning": "Door te ondertekenen wordt de PDF vrijgegeven aan de werknemer.",
          "managerSignatureNotAllowed": "U kunt deze evaluatie niet ondertekenen omdat de manager deze al heeft ondertekend.",
          "employeeSignatureNotAllowed": "U kunt deze evaluatie niet ondertekenen omdat de persoon deze al heeft ondertekend.",
          "successMessage": "Evaluatie succesvol ondertekend.",
          "updateCommentSuccessMessage": "Opmerking succesvol bijgewerkt.",
          "noComments": "U moet opmerkingen geven voordat u ondertekent."
        }
      }
    }
  },
  "security": {
    "menuTitle": "Beveiliging",
    "resource": {
      "menuName": "Bron",
      "pageTitle": "Bron",
      "add": "Bron toevoegen",
      "edit": "Bron bewerken",
      "delete": {
        "title": "Bron verwijderen",
        "text": "Weet u zeker dat u deze bron wilt verwijderen?"
      },
      "id": "Id",
      "name": "Naam",
      "description": "Beschrijving",
      "resourceType": "Brontype",
      "isActive": "Actief",
      "messages": {
        "created": "Bron succesvol aangemaakt.",
        "updated": "Bron succesvol bijgewerkt.",
        "deleted": "Bron succesvol verwijderd.",
        "notFound": "Bron niet gevonden",
        "duplicateName": "Er bestaat al een bron met deze naam.",
        "inUse": "De bron wordt gebruikt. Verwijder eerst het gebruik ervan."
      }
    },
    "user": {
      "menuName": "Gebruiker",
      "pageTitle": "Gebruiker",
      "subgridName": "Gebruikersaccount",
      "uniqueId": "Uniek ID",
      "add": "Gebruikersaccount toevoegen",
      "edit": "Gebruikersaccount bewerken",
      "delete": {
        "title": "Gebruikersaccount verwijderen",
        "text": "Weet u zeker dat u dit gebruikersaccount wilt verwijderen?"
      },
      "personId": "Id",
      "provider": "Provider",
      "userName": "Gebruikersnaam",
      "isActive": "Actief",
      "messages": {
        "created": "Gebruikersaccount succesvol aangemaakt.",
        "updated": "Gebruikersaccount succesvol bijgewerkt.",
        "deleted": "Gebruikersaccount succesvol verwijderd.",
        "notFound": "Gebruikersaccount niet gevonden",
        "duplicateName": "Deze gebruikersnaam bestaat al."
      }
    },
    "group": {
      "menuName": "Groep",
      "pageTitle": "Groep",
      "add": "Groep toevoegen",
      "edit": "Groep bewerken",
      "delete": {
        "title": "Groep verwijderen?",
        "text": "Weet u zeker dat u deze groep wilt verwijderen?"
      },
      "id": "Id",
      "name": "Naam",
      "description": "Beschrijving",
      "isActive": "Actief",
      "overwriteGroups": "Groepen overschrijven",
      "messages": {
        "created": "Groep succesvol aangemaakt.",
        "updated": "Groep succesvol bijgewerkt.",
        "deleted": "Groep succesvol verwijderd.",
        "notFound": "Groep niet gevonden",
        "duplicateName": "Er bestaat al een groep met deze naam.",
        "fileRequired": "Het bestand is verplicht.",
        "imported": "De groepen zijn correct geïmporteerd"
      }
    },
    "groupPeople": {
      "menuName": "Groepspersonen",
      "pageTitle": "Groepspersonen",
      "add": "Groepspersoon toevoegen",
      "edit": "Groepspersoon bewerken",
      "delete": {
        "title": "Groepspersoon verwijderen",
        "text": "Weet u zeker dat u deze groepspersoon wilt verwijderen?"
      },
      "groupId": "Groep",
      "personId": "Persoon",
      "validityStart": "Startdatum geldigheid",
      "validityEnd": "Einddatum geldigheid",
      "messages": {
        "created": "Groepspersoon succesvol aangemaakt.",
        "updated": "Groepspersoon succesvol bijgewerkt.",
        "deleted": "Groepspersoon succesvol verwijderd.",
        "notFound": "Groepspersoon niet gevonden",
        "alreadyExists": "De gebruiker maakt al gebruik van deze groep."
      }
    },
    "groupPermission": {
      "menuName": "Groepsrecht",
      "pageTitle": "Groepsrecht",
      "add": "Groepsrecht toevoegen",
      "edit": "Groepsrecht bewerken",
      "delete": {
        "title": "Groepsrecht verwijderen",
        "text": "Weet u zeker dat u dit groepsrecht wilt verwijderen?"
      },
      "groupId": "Groep",
      "resourceId": "Bron",
      "action": "Actie",
      "messages": {
        "created": "Groepsrecht succesvol aangemaakt.",
        "updated": "Groepsrecht succesvol bijgewerkt.",
        "deleted": "Groepsrecht succesvol verwijderd.",
        "notFound": "Groepsrecht niet gevonden",
        "duplicateName": "Er bestaat al een recht met deze bron/dit recht."
      }
    }
  },
  "goals": {
    "menuName": "Doelen",
    "kpi": {
      "menuName": "KPI"
    },
    "plan": {
      "menuName": "Plannen"
    },
    "target": {
      "menuName": "Doelstellingen",
      "kpiOwner": {
        "menuName": "Doelstellingen - KPI-eigenaar"
      }
    },
    "actual": {
      "menuName": "Realisaties",
      "kpiOwner": {
        "menuName": "Realisaties - KPI-eigenaar"
      }
    },
    "discussionNotes": {
      "menuName": "Gespreksnotities"
    },
    "flexibleGoal": {
      "menuName": "Flexibel doel"
    },
    "actionPlan": {
      "menuName": "Actieplannen"
    },
    "library": {
      "menuName": "Bibliotheek"
    },
    "category": {
      "menuName": "Categorie"
    },
    "PlantArea": {
      "menuName": "Vestigingsgebied"
    },
    "clerks": {
      "menuName": "KPI-eigenaren"
    },
    "quickEntry": {
      "menuName": "Jaarlijkse snelle invoer"
    }
  },
  "nineBox": {
    "menuName": "9box",
    "nineBoxForm": {
      "menuName": "Formulier"
    },
    "nineBoxFormPeople": {
      "menuName": "Formulierdeelnemers"
    },
    "fillTalentTalk": {
      "menuName": "Talentgesprek invullen"
    },
    "nineBoxCalibration": {
      "menuName": "Kalibratie"
    },
    "fillDevelopmentPlan": {
      "menuName": "Ontwikkelplan invullen"
    }
  },
  "pcf": {
    "menuName": "PCF",
    "dashboard": {
      "menuName": "Dashboard"
    },
    "request": {
      "newPCF": {
        "menuName": "Nieuwe PCF"
      }
    },
    "requestType": {
      "menuName": "Aanvraagtype"
    },
    "approvalGroup": {
      "menuName": "Goedkeuringsgroep"
    },
    "requestStatuses": {
      "menuName": "Aanvraagstatussen"
    },
    "catalog": {
      "menuName": "Catalogus"
    },
    "immigrationType": {
      "menuName": "Immigratietype"
    }
  },
  "merit": {
    "menuName": "Merit",
    "meritPlanFormList": {
      "menuName": "Formulierdeelnemers"
    },
    "meritDashboard": {
      "menuName": "Dashboard"
    },
    "meritPlan": {
      "menuName": "Plan"
    },
    "awardLetter": {
      "menuName": "Toekenningsbrief"
    },
    "meritPlanParticipants": {
      "menuName": "Plandeelnemers"
    }
  },
  "bonus": {
    "menuName": "Bonus",
    "bonusIncentiveGroup": {
      "menuName": "Incentivegroep"
    },
    "bonusPlan": {
      "menuName": "Plan"
    },
    "bonusPlanParticipants": {
      "menuName": "Plandeelnemers"
    },
    "bonusDashboard": {
      "menuName": "Dashboard"
    },
    "awardLetter": {
      "menuName": "Toekenningsbrief"
    },
    "saipAllocation": {
      "menuName": "SAIP-toewijzing",
      "messages": {
        "notFound": "SAIP-toewijzing niet gevonden.",
        "saveError": "Er is een fout opgetreden bij het opslaan van de SAIP-toewijzing. Probeer het opnieuw.",
        "saveSuccess": "SAIP-toewijzing succesvol opgeslagen.",
        "deleteSuccess": "SAIP-toewijzing succesvol verwijderd.",
        "isInUse": "SAIP-toewijzing is in gebruik en kan niet worden verwijderd.",
        "duplicateValueCode": "SAIP-toewijzingswaarden mogen geen dubbele codes hebben.",
        "duplicateExternalId": "Er bestaat al een SAIP-toewijzing met dit externe ID.",
        "valuesSumExceeded": "SAIP-toewijzingswaarden mogen niet meer dan 100% samen bedragen."
      }
    }
  },
  "cultureTalent": {
    "menuName": "Cultuur & Talent",
    "culture": {
      "menuName": "Cultuur- en talentprogramma's"
    },
    "talent": {
      "menuName": "Trainingsplatforms"
    }
  },
  "talentMapping": {
    "menuName": "Talentmapping",
    "skills": {
      "menuName": "Vaardigheden"
    },
    "orgChart": {
      "menuName": "Organogram"
    },
    "myProfile": {
      "menuName": "Mijn profiel"
    },
    "degreeTypes": {
      "menuName": "Diplomatype",
      "pageTitle": "Diplomatype",
      "name": "Naam",
      "isActive": "Actief",
      "add": "Diplomatype toevoegen",
      "edit": "Diplomatype bewerken",
      "delete": {
        "title": "Diplomatype verwijderen",
        "text": "Weet u zeker dat u dit diplomatype wilt verwijderen?"
      },
      "messages": {
        "created": "Diplomatype succesvol aangemaakt.",
        "updated": "Diplomatype succesvol bijgewerkt.",
        "deleted": "Diplomatype succesvol verwijderd.",
        "saveError": "Er is een fout opgetreden bij het opslaan van het diplomatype. Probeer het opnieuw.",
        "notFound": "Diplomatype niet gevonden.",
        "inUse": "Diplomatype is in gebruik en kan niet worden verwijderd."
      }
    }
  },
  "absenceRequest": {
    "menuName": "Verzuimaanvraag",
    "createRequest": {
      "menuName": "Aanvraag aanmaken"
    },
    "viewManageRequests": {
      "menuName": "Mijn aanvragen"
    },
    "calendar": {
      "menuName": "Kalender"
    },
    "pendingRequestsAndHistory": {
      "menuName": "Goedkeuringen"
    },
    "manageDirectReportsHours": {
      "menuName": "Saldi beheren"
    },
    "upload": {
      "menuName": "Uploaden"
    },
    "manageAbsenceProfiles": {
      "menuName": "Verzuimprofielen beheren"
    },
    "manageHolidays": {
      "menuName": "Feestdagen beheren"
    },
    "hoursCalculationMatrices": {
      "menuName": "Urenberekeningsmatrices"
    },
    "manageApprovingDelegate": {
      "menuName": "Goedkeuring afvaardigen"
    },
    "notification": {
      "menuName": "Verzuimmelding"
    },
    "manageMatrixCategories": {
      "menuName": "Matrixcategorieën beheren"
    },
    "manageFloatingHolidayMatrix": {
      "menuName": "Matrix flexibele feestdagen beheren"
    },
    "manageSickMatrix": {
      "menuName": "Ziekteverzuimmatrix beheren"
    }
  },
  "expenseReport": {
    "menuName": "Onkostendeclaraties",
    "createExpenses": {
      "menuName": "Aanvraag aanmaken"
    },
    "myExpenses": {
      "menuName": "Mijn aanvragen"
    },
    "approvals": {
      "menuName": "Goed te keuren onkosten"
    },
    "delegateApprovals": {
      "menuName": "Goedkeuring afvaardigen"
    },
    "preparers": {
      "menuName": "Opstellers"
    },
    "categories": {
      "menuName": "Categorieën"
    },
    "distanceRates": {
      "menuName": "Afstandstarieven"
    },
    "generalLedgers": {
      "menuName": "Grootboeken"
    },
    "policies": {
      "menuName": "Beleid"
    },
    "projects": {
      "menuName": "Projecten"
    }
  },
  "salaryExtraPay": {
    "menuName": "Salaris 6e/7e dag toeslag",
    "createRequest": {
      "menuName": "Aanvraag aanmaken"
    },
    "myRequests": {
      "menuName": "Mijn aanvragen"
    },
    "approvals": {
      "menuName": "Goedkeuringen"
    },
    "delegateApprovals": {
      "menuName": "Goedkeuring afvaardigen"
    },
    "locationSetups": {
      "menuName": "Locatie-instellingen"
    },
    "export": {
      "menuName": "Exporteren"
    },
    "policies": {
      "menuName": "Beleid"
    },
    "payType": {
      "menuName": "Betalingstypen"
    },
    "personnelAreaSetups": {
      "menuName": "Personeelsgebied-instellingen"
    }
  },
  "developmentPlan": {
    "menuName": "Ontwikkelplan",
    "planDelegate": {
      "menuName": "Planafgevaardigde"
    },
    "questions": {
      "menuName": "Vragen"
    },
    "plans": {
      "menuName": "Plannen"
    },
    "programs": {
      "menuName": "Programma's"
    },
    "notificationSender": {
      "menuName": "Meldingsverzender"
    },
    "fillDevelopmentPlan": {
      "menuName": "Ontwikkelplan invullen"
    },
    "signEvaluations": {
      "menuName": "Evaluaties ondertekenen"
    },
    "resultViewer": {
      "menuName": "Resultatenviewer"
    }
  },
  "survey": {
    "menuName": "Enquête",
    "questionCategories": {
      "menuName": "Vraagcategorieën"
    },
    "questions": {
      "menuName": "Vragen"
    },
    "ratingScales": {
      "menuName": "Beoordelingsschalen"
    },
    "actionPlans": {
      "menuName": "Actieplan"
    },
    "people": {
      "menuName": "Personen"
    },
    "surveys": {
      "menuName": "Enquêteformulieren"
    },
    "notificationSender": {
      "menuName": "Meldingsverzender"
    },
    "dashboard": {
      "menuName": "Dashboard"
    }
  },
  "hourlyPositions": {
    "menuName": "Uurloonfuncties",
    "createRequest": {
      "menuName": "Aanvraag aanmaken"
    },
    "requests": {
      "menuName": "Aanvragen"
    },
    "employeeSubgroup": {
      "menuName": "Werknemerssubgroep"
    },
    "hourlyCatalog": {
      "menuName": "Uurlooncatalogus"
    }
  },
  "vuestic": {
    "search": "Zoeken",
    "noOptions": "Geen items gevonden",
    "ok": "OK",
    "cancel": "Annuleren",
    "uploadFile": "Bestand selecteren",
    "undo": "Ongedaan maken",
    "dropzone": "Sleep bestanden hierheen om te uploaden",
    "fileDeleted": "Bestand verwijderd",
    "closeAlert": "melding sluiten",
    "backToTop": "terug naar boven",
    "toggleDropdown": "vervolgkeuzelijst wisselen",
    "carousel": "carrousel",
    "goPreviousSlide": "ga naar vorige slide",
    "goNextSlide": "ga naar volgende slide",
    "goSlide": "ga naar slide {index}",
    "slideOf": "slide {index} van {length}",
    "close": "sluiten",
    "openColorPicker": "kleurkiezer openen",
    "colorSelection": "kleurselectie",
    "colorName": "kleur {color}",
    "decreaseCounter": "teller verlagen",
    "increaseCounter": "teller verhogen",
    "selectAllRows": "alle rijen selecteren",
    "sortColumnBy": "kolom sorteren op {name}",
    "selectRowByIndex": "rij {index} selecteren",
    "resetDate": "datum resetten",
    "nextPeriod": "volgende periode",
    "switchView": "weergave wisselen",
    "previousPeriod": "vorige periode",
    "removeFile": "bestand verwijderen",
    "reset": "resetten",
    "pagination": "paginering",
    "goToTheFirstPage": "ga naar de eerste pagina",
    "goToPreviousPage": "ga naar de vorige pagina",
    "goToSpecificPage": "ga naar pagina {page}",
    "goToSpecificPageInput": "voer paginanummer in",
    "goNextPage": "ga naar de volgende pagina",
    "goLastPage": "ga naar de laatste pagina",
    "currentRating": "huidige beoordeling {value} van {max}",
    "voteRating": "beoordeling stemmen {value} van {max}",
    "optionsFilter": "optiesfilter",
    "splitPanels": "gesplitste panelen",
    "movePaginationLeft": "paginering naar links verplaatsen",
    "movePaginationRight": "paginering naar rechts verplaatsen",
    "resetTime": "tijd resetten",
    "closeToast": "melding sluiten",
    "selectedOption": "Geselecteerde optie",
    "noSelectedOption": "Geen optie geselecteerd",
    "breadcrumbs": "broodkruimelpad",
    "counterValue": "tellerwaarde",
    "selectedDate": "geselecteerde datum",
    "selectedTime": "geselecteerde tijd",
    "progressState": "voortgangsstatus",
    "color": "kleur",
    "next": "Volgende",
    "back": "Terug",
    "finish": "Voltooien",
    "step": "stap",
    "progress": "voortgang",
    "loading": "Laden",
    "sliderValue": "De huidige schuifregelaarwaarde is {value}",
    "switch": "Schakelaar",
    "inputField": "Invoerveld",
    "fileTypeIncorrect": "Onjuist bestandstype",
    "select": "Selecteer een optie"
  },
  "orgChart": {
    "title": "Organogram",
    "menuTitle": "Organogram",
    "menuName": "Organogram",
    "organization": "Organisatie",
    "directReports": "Directe rapportagelijnen",
    "showEmployeeDetails": "Werknemersgegevens tonen",
    "goUp": "Eén niveau omhoog",
    "navigateHere": "Hierheen navigeren",
    "vacant": "Vacant",
    "legend": {
      "active": "Actief",
      "inactive": "Inactief",
      "termed": "Uit dienst",
      "vacant": "Vacant"
    },
    "position": "Functie",
    "plant": "Vestiging",
    "businessArea": "Bedrijfsgebied",
    "personnelArea": "Personeelsgebied",
    "costCenter": "Kostenplaats",
    "hireDate": "Indiensttredingsdatum",
    "score360": "360-score",
    "scoreGoals": "Doelenscore",
    "score9box": "9-Box",
    "person": "Persoon",
    "employeeType": "Type werknemer",
    "employeeStatus": "Werknemersstatus",
    "status": "Status",
    "view": "Bekijken",
    "viewOptions": {
      "basic": "Basis",
      "performance": "Prestaties",
      "headcount": "Personeelsbestand"
    },
    "headcount": {
      "directTotal": "Direct totaal",
      "directSESNE": "Direct SE/SNE",
      "total": "Totaal personeelsbestand",
      "spanOfControl": "Span of control",
      "se": "Salariswerknemers",
      "sne": "SNE-werknemers",
      "hourly": "Uurloonwerknemers",
      "truck": "Vrachtwagenchauffeurs",
      "work": "Werkvrijstellingswerknemers"
    },
    "hidePeers": "Collega's verbergen",
    "showPeers": "Collega('s) tonen",
    "collapse": "Samenvouwen",
    "expand": "Uitvouwen",
    "errors": {
      "salariedTypeCannotBeRemoved": "Salaristype kan niet worden verwijderd.",
      "employeeNotInTree": "Deze werknemer bevindt zich buiten de structuur van het organogram en kan niet worden weergegeven."
    }
  }
}
